import { n as e, t } from "../../utils-DiFe-_ei.js";
import { Button as n } from "../../foundations/button.js";
import "../../button-C8zrAH2m.js";
import { t as r } from "../../createLucideIcon-CJLgHpqc.js";
import { t as i } from "../../x-DCbCFsrz.js";
import { t as a } from "../../checkbox-BNSdvisy.js";
import "../../checkbox-9kLtro67.js";
import { a as o, h as s, n as c, o as l, r as u, t as d, u as ee } from "../../dropdown-menu-BLAt-Aef.js";
import "../../dropdown-menu-DPef8Amn.js";
import { Skeleton as f } from "../../foundations/skeleton.js";
import "../../skeleton-bhKtal4a.js";
import { Table as p, TableBody as m, TableCell as h, TableHead as te, TableHeader as g, TableRow as _ } from "../../foundations/table.js";
import "../../table-C2NUiEcU.js";
import { Typography as v } from "../../foundations/typography.js";
import "../../typography-CTPDhvds.js";
import { i as y, n as b, t as x } from "../../tooltip-BBk91-lt.js";
import "../../tooltip-CVlMtE-y.js";
import { t as ne } from "../../dist-V_vBpdZH.js";
import { t as re } from "../../Avatar-DPnco3PK.js";
import { t as ie } from "../../Pagination-Dh2R94_t.js";
import { Fragment as S, useEffect as ae, useMemo as oe, useRef as se, useState as ce } from "react";
import { Fragment as le, jsx as C, jsxs as w } from "react/jsx-runtime";
import { flexRender as ue, getCoreRowModel as T, getSortedRowModel as de, useReactTable as fe } from "@tanstack/react-table";
import { EditorContent as pe, useEditor as me } from "@tiptap/react";
import { StarterKit as he } from "@tiptap/starter-kit";
var ge = r("arrow-down", [["path", {
	d: "M12 5v14",
	key: "s699le"
}], ["path", {
	d: "m19 12-7 7-7-7",
	key: "1idqje"
}]]), _e = r("arrow-up-down", [
	["path", {
		d: "m21 16-4 4-4-4",
		key: "f6ql7i"
	}],
	["path", {
		d: "M17 20V4",
		key: "1ejh1v"
	}],
	["path", {
		d: "m3 8 4-4 4 4",
		key: "11wl7u"
	}],
	["path", {
		d: "M7 4v16",
		key: "1glfcx"
	}]
]), ve = r("arrow-up", [["path", {
	d: "m5 12 7-7 7 7",
	key: "hav0vg"
}], ["path", {
	d: "M12 19V5",
	key: "x0mq9r"
}]]), ye = r("bell-off", [
	["path", {
		d: "M10.268 21a2 2 0 0 0 3.464 0",
		key: "vwvbt9"
	}],
	["path", {
		d: "M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742",
		key: "178tsu"
	}],
	["path", {
		d: "m2 2 20 20",
		key: "1ooewy"
	}],
	["path", {
		d: "M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05",
		key: "1hqiys"
	}]
]), E = r("bell", [["path", {
	d: "M10.268 21a2 2 0 0 0 3.464 0",
	key: "vwvbt9"
}], ["path", {
	d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
	key: "11g9vi"
}]]), be = r("bold", [["path", {
	d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8",
	key: "mg9rjx"
}]]), D = r("columns-3", [
	["rect", {
		width: "18",
		height: "18",
		x: "3",
		y: "3",
		rx: "2",
		key: "afitv7"
	}],
	["path", {
		d: "M9 3v18",
		key: "fh3hqa"
	}],
	["path", {
		d: "M15 3v18",
		key: "14nvp0"
	}]
]), xe = r("ellipsis", [
	["circle", {
		cx: "12",
		cy: "12",
		r: "1",
		key: "41hilf"
	}],
	["circle", {
		cx: "19",
		cy: "12",
		r: "1",
		key: "1wjl8i"
	}],
	["circle", {
		cx: "5",
		cy: "12",
		r: "1",
		key: "1pcz8c"
	}]
]), O = r("eye", [["path", {
	d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
	key: "1nclc0"
}], ["circle", {
	cx: "12",
	cy: "12",
	r: "3",
	key: "1v7zrd"
}]]), Se = r("italic", [
	["line", {
		x1: "19",
		x2: "10",
		y1: "4",
		y2: "4",
		key: "15jd3p"
	}],
	["line", {
		x1: "14",
		x2: "5",
		y1: "20",
		y2: "20",
		key: "bu0au3"
	}],
	["line", {
		x1: "15",
		x2: "9",
		y1: "4",
		y2: "20",
		key: "uljnxc"
	}]
]), Ce = r("list-ordered", [
	["path", {
		d: "M11 5h10",
		key: "1cz7ny"
	}],
	["path", {
		d: "M11 12h10",
		key: "1438ji"
	}],
	["path", {
		d: "M11 19h10",
		key: "11t30w"
	}],
	["path", {
		d: "M4 4h1v5",
		key: "10yrso"
	}],
	["path", {
		d: "M4 9h2",
		key: "r1h2o0"
	}],
	["path", {
		d: "M6.5 20H3.4c0-1 2.6-1.925 2.6-3.5a1.5 1.5 0 0 0-2.6-1.02",
		key: "xtkcd5"
	}]
]), k = r("list", [
	["path", {
		d: "M3 5h.01",
		key: "18ugdj"
	}],
	["path", {
		d: "M3 12h.01",
		key: "nlz23k"
	}],
	["path", {
		d: "M3 19h.01",
		key: "noohij"
	}],
	["path", {
		d: "M8 5h13",
		key: "1pao27"
	}],
	["path", {
		d: "M8 12h13",
		key: "1za7za"
	}],
	["path", {
		d: "M8 19h13",
		key: "m83p4d"
	}]
]), we = r("mail", [["path", {
	d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7",
	key: "132q7q"
}], ["rect", {
	x: "2",
	y: "4",
	width: "20",
	height: "16",
	rx: "2",
	key: "izxlao"
}]]), Te = r("pin", [["path", {
	d: "M12 17v5",
	key: "bb1du9"
}], ["path", {
	d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
	key: "1nkz8b"
}]]), Ee = r("pin-off", [
	["path", {
		d: "M12 17v5",
		key: "bb1du9"
	}],
	["path", {
		d: "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89",
		key: "znwnzq"
	}],
	["path", {
		d: "m2 2 20 20",
		key: "1ooewy"
	}],
	["path", {
		d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11",
		key: "c9qhm2"
	}]
]), De = r("send", [["path", {
	d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
	key: "1ffxy3"
}], ["path", {
	d: "m21.854 2.147-10.94 10.939",
	key: "12cjpa"
}]]), A = r("square", [["rect", {
	width: "18",
	height: "18",
	x: "3",
	y: "3",
	rx: "2",
	key: "afitv7"
}]]), j = r("undo-2", [["path", {
	d: "M9 14 4 9l5-5",
	key: "102s5s"
}], ["path", {
	d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11",
	key: "f3b9sd"
}]]);
//#endregion
//#region src/components/data/data-table/BulkActionBar/BulkActionBar.tsx
function Oe({ selectedCount: e, actions: r, onClearSelection: a, className: o }) {
	return e === 0 ? null : /* @__PURE__ */ w("div", {
		className: t("flex items-center gap-3 rounded-lg border bg-muted/60 px-4 py-2 text-sm", o),
		children: [
			/* @__PURE__ */ w("span", {
				className: "text-muted-foreground font-medium",
				children: [e, " selected"]
			}),
			/* @__PURE__ */ C("div", {
				className: "flex items-center gap-2",
				children: r.map((e) => /* @__PURE__ */ w(n, {
					variant: e.variant === "destructive" ? "destructive" : "outline",
					size: "sm",
					onClick: e.onClick,
					disabled: e.disabled,
					children: [e.icon, e.label]
				}, e.label))
			}),
			/* @__PURE__ */ C("div", {
				className: "ml-auto",
				children: /* @__PURE__ */ C(n, {
					variant: "ghost",
					size: "icon",
					onClick: a,
					"aria-label": "Clear selection",
					children: /* @__PURE__ */ C(i, { className: "size-4" })
				})
			})
		]
	});
}
//#endregion
//#region src/components/data/data-table/ColumnVisibilityMenu/ColumnVisibilityMenu.tsx
function ke({ columns: e, columnVisibility: t, onColumnVisibilityChange: r }) {
	function i(e, n) {
		r({
			...t,
			[e]: n
		});
	}
	return /* @__PURE__ */ w(d, { children: [/* @__PURE__ */ C(s, {
		asChild: !0,
		children: /* @__PURE__ */ C(n, {
			variant: "outline",
			size: "sm",
			className: "text-muted-foreground hover:text-foreground h-9 w-9 shrink-0 rounded-lg p-0",
			"aria-label": "Toggle columns",
			title: "Columns",
			children: /* @__PURE__ */ C(D, { className: "size-4" })
		})
	}), /* @__PURE__ */ w(u, {
		align: "end",
		className: "min-w-[160px]",
		children: [
			/* @__PURE__ */ C(l, { children: "Toggle columns" }),
			/* @__PURE__ */ C(ee, {}),
			e.map((e) => /* @__PURE__ */ C(c, {
				checked: t[e.id] !== !1,
				onCheckedChange: (t) => i(e.id, t),
				onSelect: (e) => e.preventDefault(),
				children: e.label
			}, e.id))
		]
	})] });
}
//#endregion
//#region src/components/data/data-table/DataTable/DataTable.constants.ts
var Ae = "__select__", je = 8, Me = 1, Ne = "bg-[color-mix(in_oklab,var(--color-muted)_40%,var(--color-background))]", Pe = "bg-background transition-colors group-hover/row:bg-[color-mix(in_oklab,var(--color-muted)_50%,var(--color-background))] group-data-[state=selected]/row:bg-muted", Fe = [
	"w-3/4",
	"w-1/2",
	"w-2/3",
	"w-1/3",
	"w-5/6"
];
function Ie({ direction: e }) {
	return e === "asc" ? /* @__PURE__ */ C(ve, { className: "h-3.5 w-3.5" }) : e === "desc" ? /* @__PURE__ */ C(ge, { className: "h-3.5 w-3.5" }) : /* @__PURE__ */ C(_e, { className: "text-muted-foreground h-3.5 w-3.5" });
}
function Le({ label: e, isSorted: t }) {
	return /* @__PURE__ */ w("span", {
		className: "flex items-center gap-1",
		children: [e, /* @__PURE__ */ C(Ie, { direction: t })]
	});
}
function Re({ columnLabel: e, isPinned: r, onToggle: i }) {
	let a = r ? Ee : Te;
	return /* @__PURE__ */ C(n, {
		variant: "ghost",
		size: "icon",
		className: t("size-6 shrink-0 rounded-md", r ? "text-foreground" : "text-muted-foreground/60 hover:text-foreground"),
		onClick: i,
		"aria-label": `${r ? "Unpin" : "Pin"} ${e} column`,
		"aria-pressed": r,
		children: /* @__PURE__ */ C(a, { className: "size-3.5" })
	});
}
function ze({ columnCount: e }) {
	return /* @__PURE__ */ C(le, { children: Array.from({ length: je }, (t, n) => /* @__PURE__ */ C(_, {
		className: "hover:bg-transparent",
		children: Array.from({ length: e }, (e, t) => /* @__PURE__ */ C(h, {
			className: "py-3",
			children: /* @__PURE__ */ C(f, {
				variant: "text",
				className: Fe[(n + t) % Fe.length]
			})
		}, t))
	}, n)) });
}
function Be({ columns: e, data: r, isLoading: i, emptyMessage: o = "No results.", onRowClick: s, sorting: c, onSortingChange: l, manualSorting: u = !1, columnVisibility: d, onColumnVisibilityChange: ee, enableColumnPinning: f = !1, pinnedColumnId: v, onPinnedColumnChange: y, className: b, enableSelection: x = !1, isRowSelectable: ne, getRowId: re, rowSelection: ie, onRowSelectionChange: S, onSelectionChange: le, clearSelectionOnDataChange: pe = !0, stickyHeader: me = !1 }) {
	let he = se(null), ge = se(null), [_e, ve] = ce({
		hasStart: !1,
		hasEnd: !1
	}), [ye, E] = ce(0), [be, D] = ce(), [xe, O] = ce([]), [Se, Ce] = ce({}), k = ie !== void 0, we = k ? ie : Se, Te = u || c !== void 0 && l !== void 0, Ee = Te ? c ?? [] : xe, De = (e, t) => re ? re(e) : String(t);
	function A(e) {
		let t = typeof e == "function" ? e(Ee) : e;
		Te ? l?.(t) : O(t);
	}
	function j(e) {
		let t = typeof e == "function" ? e(d ?? {}) : e;
		ee?.(t);
	}
	function Oe(e) {
		let t = typeof e == "function" ? e(we) : e;
		k || Ce(t), S?.(e);
	}
	ae(() => {
		le && le(r.filter((e, t) => we[De(e, t)]));
	}, [we]), ae(() => {
		pe && (k ? S?.((e) => Object.keys(e).length === 0 ? e : {}) : Ce((e) => Object.keys(e).length === 0 ? e : {}));
	}, [r]);
	let ke = oe(() => ({
		id: Ae,
		enableSorting: !1,
		enableHiding: !1,
		header: ({ table: e }) => /* @__PURE__ */ C("div", {
			className: "-m-2 inline-flex p-2",
			children: /* @__PURE__ */ C(a, {
				checked: e.getIsAllRowsSelected() ? !0 : e.getIsSomeRowsSelected() ? "indeterminate" : !1,
				onCheckedChange: (t) => e.toggleAllRowsSelected(!!t),
				"aria-label": "Select all rows"
			})
		}),
		cell: ({ row: e }) => /* @__PURE__ */ C("div", {
			className: "-m-2 inline-flex p-2",
			onClick: (e) => e.stopPropagation(),
			children: /* @__PURE__ */ C(a, {
				checked: e.getIsSelected(),
				disabled: !e.getCanSelect(),
				onCheckedChange: (t) => e.toggleSelected(!!t),
				"aria-label": "Select row"
			})
		})
	}), []), je = x ? [ke, ...e] : e, Fe = (e) => e.id ?? ("accessorKey" in e ? String(e.accessorKey) : void 0), Ie = v === void 0 ? be : v, Be = e.find((e) => e.meta?.sticky), M = Ie === void 0 ? (Be && Fe(Be)) ?? null : Ie, N = e.map((e) => e.enableHiding === !1 ? void 0 : Fe(e)).find((e) => e && d?.[e] !== !1), Ve = M && M === N ? [M] : [];
	function He(e) {
		let t = M === e ? null : e;
		D(t), y?.(t);
	}
	let Ue = Ve.length > 0, We = Ue ? [...x ? [Ae] : [], ...Ve] : [], Ge = fe({
		data: r,
		columns: je,
		getCoreRowModel: T(),
		getSortedRowModel: de(),
		enableRowSelection: x ? (e) => ne?.(e.original) ?? !0 : !1,
		onSortingChange: A,
		onColumnVisibilityChange: j,
		onRowSelectionChange: Oe,
		getRowId: (e, t) => De(e, t),
		state: {
			sorting: Ee,
			columnVisibility: d ?? {},
			rowSelection: we,
			columnPinning: {
				left: We,
				right: []
			}
		},
		manualSorting: u
	});
	return ae(() => {
		let e = he.current, t = e?.parentElement;
		if (!e || !t) return;
		function n() {
			if (!t) return;
			let e = t.scrollWidth - t.clientWidth, n = t.scrollLeft > Me, r = t.scrollLeft < e - Me;
			ve((e) => e.hasStart === n && e.hasEnd === r ? e : {
				hasStart: n,
				hasEnd: r
			}), E(ge.current?.offsetWidth ?? 0);
		}
		if (n(), t.addEventListener("scroll", n, { passive: !0 }), typeof ResizeObserver > "u") return () => t.removeEventListener("scroll", n);
		let r = new ResizeObserver(n);
		return r.observe(t), r.observe(e), () => {
			t.removeEventListener("scroll", n), r.disconnect();
		};
	}, [
		r,
		i,
		d,
		x
	]), /* @__PURE__ */ w("div", {
		className: t("relative overflow-hidden rounded-lg border", me && "flex flex-col", b),
		children: [
			_e.hasEnd && /* @__PURE__ */ C("div", {
				"aria-hidden": !0,
				"data-testid": "scroll-fade-end",
				className: "from-background pointer-events-none absolute inset-y-0 right-0 z-20 w-8 bg-linear-to-l to-transparent"
			}),
			_e.hasStart && !Ue && /* @__PURE__ */ C("div", {
				"aria-hidden": !0,
				"data-testid": "scroll-fade-start",
				className: "from-background pointer-events-none absolute inset-y-0 left-0 z-20 w-8 bg-linear-to-r to-transparent"
			}),
			/* @__PURE__ */ w(p, {
				ref: he,
				children: [/* @__PURE__ */ C(g, {
					className: "bg-muted/40",
					children: Ge.getHeaderGroups().map((e) => /* @__PURE__ */ C(_, {
						className: "hover:bg-muted/40",
						children: e.headers.map((e) => {
							let r = e.column.getCanSort(), i = e.column.getIsSorted(), a = e.column.id === Ae, o = e.column.getIsPinned() === "left", s = e.column.getIsLastColumn("left"), c = e.isPlaceholder ? null : ue(e.column.columnDef.header, e.getContext());
							return /* @__PURE__ */ C(te, {
								ref: a ? ge : void 0,
								style: o ? { left: a ? 0 : ye } : void 0,
								className: t(o && ["sticky z-10", Ne], me && ["sticky top-0 z-20 shadow-[inset_0_-1px_0_var(--color-border)]", Ne], s && _e.hasStart && "border-r", "whitespace-nowrap", "h-10 text-xs font-medium tracking-wide text-muted-foreground", e.column.columnDef.meta?.align === "right" ? "text-right" : void 0),
								children: /* @__PURE__ */ w("div", {
									className: t("flex items-center gap-1", e.column.columnDef.meta?.align === "right" && "justify-end"),
									children: [r ? /* @__PURE__ */ C(n, {
										variant: "ghost",
										size: "sm",
										className: "text-muted-foreground hover:text-foreground -ml-2 h-7 rounded-md px-2 text-xs font-medium tracking-wide",
										onClick: e.column.getToggleSortingHandler(),
										"aria-label": `Sort by ${typeof e.column.columnDef.header == "string" ? e.column.columnDef.header : e.column.id}`,
										children: /* @__PURE__ */ C(Le, {
											label: c,
											isSorted: i
										})
									}) : c, f && e.column.id === N && /* @__PURE__ */ C(Re, {
										columnLabel: typeof e.column.columnDef.header == "string" ? e.column.columnDef.header : e.column.id,
										isPinned: M === e.column.id,
										onToggle: () => He(e.column.id)
									})]
								})
							}, e.id);
						})
					}, e.id))
				}), /* @__PURE__ */ C(m, {
					"aria-busy": i || void 0,
					children: i ? /* @__PURE__ */ C(ze, { columnCount: je.length }) : Ge.getRowModel().rows.length > 0 ? Ge.getRowModel().rows.map((e) => /* @__PURE__ */ C(_, {
						"data-state": e.getIsSelected() ? "selected" : void 0,
						onClick: s ? () => {
							if (x && (Ge.getIsSomeRowsSelected() || Ge.getIsAllRowsSelected())) {
								e.toggleSelected();
								return;
							}
							s(e.original);
						} : void 0,
						className: t("group/row", s && "cursor-pointer"),
						children: e.getVisibleCells().map((e) => {
							let n = e.column.id === Ae, r = e.column.getIsPinned() === "left", i = e.column.getIsLastColumn("left");
							return /* @__PURE__ */ C(h, {
								style: r ? { left: n ? 0 : ye } : void 0,
								className: t(r && ["sticky z-10", Pe], i && _e.hasStart && "border-r", "whitespace-nowrap", "py-3", e.column.columnDef.meta?.align === "right" ? "text-right" : void 0, e.column.columnDef.meta?.truncate && "max-w-[16rem] truncate"),
								children: ue(e.column.columnDef.cell, e.getContext())
							}, e.id);
						})
					}, e.id)) : /* @__PURE__ */ C(_, { children: /* @__PURE__ */ C(h, {
						colSpan: je.length,
						className: "text-muted-foreground py-8 text-center text-sm",
						children: o
					}) })
				})]
			})
		]
	});
}
//#endregion
//#region src/components/data/data-table/RowActionsMenu/RowActionsMenu.tsx
function M({ triggerLabel: t, actions: r, linkComponent: i = "a" }) {
	return /* @__PURE__ */ w(d, { children: [/* @__PURE__ */ C(s, {
		asChild: !0,
		children: /* @__PURE__ */ C(n, {
			variant: "ghost",
			size: "icon",
			"aria-label": t,
			onClick: (e) => e.stopPropagation(),
			children: /* @__PURE__ */ C(xe, { className: "h-4 w-4" })
		})
	}), /* @__PURE__ */ C(u, {
		align: "end",
		children: r.map((t) => {
			let n = t.destructive ? "text-destructive-text focus:text-destructive-text" : void 0;
			return /* @__PURE__ */ w(S, { children: [t.separator && /* @__PURE__ */ C(ee, {}), t.href === void 0 ? /* @__PURE__ */ w(o, {
				onClick: t.disabled ? void 0 : t.onClick,
				disabled: t.disabled,
				className: n,
				children: [t.icon, t.label]
			}) : /* @__PURE__ */ C(o, {
				asChild: !0,
				disabled: t.disabled,
				className: n,
				children: /* @__PURE__ */ w(i, {
					...e(i, t.href),
					children: [t.icon, t.label]
				})
			})] }, t.label);
		})
	})] });
}
//#endregion
//#region src/components/data/data-table/RowActions/RowActions.tsx
function N({ viewHref: t, onViewClick: r, triggerLabel: i, actions: a, linkComponent: o = "a" }) {
	return /* @__PURE__ */ w("div", {
		className: "flex items-center justify-end",
		onClick: (e) => e.stopPropagation(),
		children: [r ? /* @__PURE__ */ w(n, {
			variant: "ghost",
			size: "icon",
			onClick: r,
			children: [/* @__PURE__ */ C(O, { className: "h-4 w-4" }), /* @__PURE__ */ C("span", {
				className: "sr-only",
				children: "Preview"
			})]
		}) : /* @__PURE__ */ C(n, {
			variant: "ghost",
			size: "icon",
			asChild: !0,
			children: /* @__PURE__ */ w(o, {
				...e(o, t),
				children: [/* @__PURE__ */ C(O, { className: "h-4 w-4" }), /* @__PURE__ */ C("span", {
					className: "sr-only",
					children: "View"
				})]
			})
		}), /* @__PURE__ */ C(M, {
			triggerLabel: i,
			actions: a,
			linkComponent: o
		})]
	});
}
//#endregion
//#region ../../node_modules/.pnpm/dompurify@3.4.12/node_modules/dompurify/dist/purify.es.mjs
function Ve(e, t) {
	(t == null || t > e.length) && (t = e.length);
	for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
	return r;
}
function He(e) {
	if (Array.isArray(e)) return e;
}
function Ue(e, t) {
	var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
	if (n != null) {
		var r, i, a, o, s = [], c = !0, l = !1;
		try {
			if (a = (n = n.call(e)).next, t !== 0) for (; !(c = (r = a.call(n)).done) && (s.push(r.value), s.length !== t); c = !0);
		} catch (e) {
			l = !0, i = e;
		} finally {
			try {
				if (!c && n.return != null && (o = n.return(), Object(o) !== o)) return;
			} finally {
				if (l) throw i;
			}
		}
		return s;
	}
}
function We() {
	throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function Ge(e, t) {
	return He(e) || Ue(e, t) || Ke(e, t) || We();
}
function Ke(e, t) {
	if (e) {
		if (typeof e == "string") return Ve(e, t);
		var n = {}.toString.call(e).slice(8, -1);
		return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ve(e, t) : void 0;
	}
}
var qe = Object.entries, Je = Object.setPrototypeOf, P = Object.isFrozen, Ye = Object.getPrototypeOf, Xe = Object.getOwnPropertyDescriptor, F = Object.freeze, I = Object.seal, Ze = Object.create, Qe = typeof Reflect < "u" && Reflect, $e = Qe.apply, et = Qe.construct;
F ||= function(e) {
	return e;
}, I ||= function(e) {
	return e;
}, $e ||= function(e, t) {
	var n = [...arguments].slice(2);
	return e.apply(t, n);
}, et ||= function(e) {
	return new e(...[...arguments].slice(1));
};
var tt = B(Array.prototype.forEach), nt = B(Array.prototype.lastIndexOf), rt = B(Array.prototype.pop), it = B(Array.prototype.push), at = B(Array.prototype.splice), ot = Array.isArray, st = B(String.prototype.toLowerCase), ct = B(String.prototype.toString), lt = B(String.prototype.match), ut = B(String.prototype.replace), dt = B(String.prototype.indexOf), ft = B(String.prototype.trim), pt = B(Number.prototype.toString), mt = B(Boolean.prototype.toString), ht = typeof BigInt > "u" ? null : B(BigInt.prototype.toString), gt = typeof Symbol > "u" ? null : B(Symbol.prototype.toString), L = B(Object.prototype.hasOwnProperty), R = B(Object.prototype.toString), z = B(RegExp.prototype.test), _t = V(TypeError);
function B(e) {
	return function(t) {
		t instanceof RegExp && (t.lastIndex = 0);
		var n = [...arguments].slice(1);
		return $e(e, t, n);
	};
}
function V(e) {
	return function() {
		return et(e, [...arguments]);
	};
}
function H(e, t) {
	let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : st;
	if (Je && Je(e, null), !ot(t)) return e;
	let r = t.length;
	for (; r--;) {
		let i = t[r];
		if (typeof i == "string") {
			let e = n(i);
			e !== i && (P(t) || (t[r] = e), i = e);
		}
		e[i] = !0;
	}
	return e;
}
function vt(e) {
	for (let t = 0; t < e.length; t++) L(e, t) || (e[t] = null);
	return e;
}
function U(e) {
	let t = Ze(null);
	for (let r of qe(e)) {
		var n = Ge(r, 2);
		let i = n[0], a = n[1];
		L(e, i) && (ot(a) ? t[i] = vt(a) : a && typeof a == "object" && a.constructor === Object ? t[i] = U(a) : t[i] = a);
	}
	return t;
}
function yt(e) {
	switch (typeof e) {
		case "string": return e;
		case "number": return pt(e);
		case "boolean": return mt(e);
		case "bigint": return ht ? ht(e) : "0";
		case "symbol": return gt ? gt(e) : "Symbol()";
		case "undefined": return R(e);
		case "function":
		case "object": {
			if (e === null) return R(e);
			let t = e, n = W(t, "toString");
			if (typeof n == "function") {
				let e = n(t);
				return typeof e == "string" ? e : R(e);
			}
			return R(e);
		}
		default: return R(e);
	}
}
function W(e, t) {
	for (; e !== null;) {
		let n = Xe(e, t);
		if (n) {
			if (n.get) return B(n.get);
			if (typeof n.value == "function") return B(n.value);
		}
		e = Ye(e);
	}
	function n() {
		return null;
	}
	return n;
}
function bt(e) {
	try {
		return z(e, ""), !0;
	} catch {
		return !1;
	}
}
var xt = F(/* @__PURE__ */ "a.abbr.acronym.address.area.article.aside.audio.b.bdi.bdo.big.blink.blockquote.body.br.button.canvas.caption.center.cite.code.col.colgroup.content.data.datalist.dd.decorator.del.details.dfn.dialog.dir.div.dl.dt.element.em.fieldset.figcaption.figure.font.footer.form.h1.h2.h3.h4.h5.h6.head.header.hgroup.hr.html.i.img.input.ins.kbd.label.legend.li.main.map.mark.marquee.menu.menuitem.meter.nav.nobr.ol.optgroup.option.output.p.picture.pre.progress.q.rp.rt.ruby.s.samp.search.section.select.shadow.slot.small.source.spacer.span.strike.strong.style.sub.summary.sup.table.tbody.td.template.textarea.tfoot.th.thead.time.tr.track.tt.u.ul.var.video.wbr".split(".")), St = F(/* @__PURE__ */ "svg.a.altglyph.altglyphdef.altglyphitem.animatecolor.animatemotion.animatetransform.circle.clippath.defs.desc.ellipse.enterkeyhint.exportparts.filter.font.g.glyph.glyphref.hkern.image.inputmode.line.lineargradient.marker.mask.metadata.mpath.part.path.pattern.polygon.polyline.radialgradient.rect.stop.style.switch.symbol.text.textpath.title.tref.tspan.view.vkern".split(".")), Ct = F([
	"feBlend",
	"feColorMatrix",
	"feComponentTransfer",
	"feComposite",
	"feConvolveMatrix",
	"feDiffuseLighting",
	"feDisplacementMap",
	"feDistantLight",
	"feDropShadow",
	"feFlood",
	"feFuncA",
	"feFuncB",
	"feFuncG",
	"feFuncR",
	"feGaussianBlur",
	"feImage",
	"feMerge",
	"feMergeNode",
	"feMorphology",
	"feOffset",
	"fePointLight",
	"feSpecularLighting",
	"feSpotLight",
	"feTile",
	"feTurbulence"
]), wt = F([
	"animate",
	"color-profile",
	"cursor",
	"discard",
	"font-face",
	"font-face-format",
	"font-face-name",
	"font-face-src",
	"font-face-uri",
	"foreignobject",
	"hatch",
	"hatchpath",
	"mesh",
	"meshgradient",
	"meshpatch",
	"meshrow",
	"missing-glyph",
	"script",
	"set",
	"solidcolor",
	"unknown",
	"use"
]), Tt = F(/* @__PURE__ */ "math.menclose.merror.mfenced.mfrac.mglyph.mi.mlabeledtr.mmultiscripts.mn.mo.mover.mpadded.mphantom.mroot.mrow.ms.mspace.msqrt.mstyle.msub.msup.msubsup.mtable.mtd.mtext.mtr.munder.munderover.mprescripts".split(".")), Et = F([
	"maction",
	"maligngroup",
	"malignmark",
	"mlongdiv",
	"mscarries",
	"mscarry",
	"msgroup",
	"mstack",
	"msline",
	"msrow",
	"semantics",
	"annotation",
	"annotation-xml",
	"mprescripts",
	"none"
]), Dt = F(["#text"]), Ot = F(/* @__PURE__ */ "accept.action.align.alt.autocapitalize.autocomplete.autopictureinpicture.autoplay.background.bgcolor.border.capture.cellpadding.cellspacing.checked.cite.class.clear.color.cols.colspan.command.commandfor.controls.controlslist.coords.crossorigin.datetime.decoding.default.dir.disabled.disablepictureinpicture.disableremoteplayback.download.draggable.enctype.enterkeyhint.exportparts.face.for.headers.height.hidden.high.href.hreflang.id.inert.inputmode.integrity.ismap.kind.label.lang.list.loading.loop.low.max.maxlength.media.method.min.minlength.multiple.muted.name.nonce.noshade.novalidate.nowrap.open.optimum.part.pattern.placeholder.playsinline.popover.popovertarget.popovertargetaction.poster.preload.pubdate.radiogroup.readonly.rel.required.rev.reversed.role.rows.rowspan.spellcheck.scope.selected.shape.size.sizes.slot.span.srclang.start.src.srcset.step.style.summary.tabindex.title.translate.type.usemap.valign.value.width.wrap.xmlns".split(".")), kt = F(/* @__PURE__ */ "accent-height.accumulate.additive.alignment-baseline.amplitude.ascent.attributename.attributetype.azimuth.basefrequency.baseline-shift.begin.bias.by.class.clip.clippathunits.clip-path.clip-rule.color.color-interpolation.color-interpolation-filters.color-profile.color-rendering.cx.cy.d.dx.dy.diffuseconstant.direction.display.divisor.dominant-baseline.dur.edgemode.elevation.end.exponent.fill.fill-opacity.fill-rule.filter.filterunits.flood-color.flood-opacity.font-family.font-size.font-size-adjust.font-stretch.font-style.font-variant.font-weight.fx.fy.g1.g2.glyph-name.glyphref.gradientunits.gradienttransform.height.href.id.image-rendering.in.in2.intercept.k.k1.k2.k3.k4.kerning.keypoints.keysplines.keytimes.lang.lengthadjust.letter-spacing.kernelmatrix.kernelunitlength.lighting-color.local.marker-end.marker-mid.marker-start.markerheight.markerunits.markerwidth.maskcontentunits.maskunits.max.mask.mask-type.media.method.mode.min.name.numoctaves.offset.operator.opacity.order.orient.orientation.origin.overflow.paint-order.path.pathlength.patterncontentunits.patterntransform.patternunits.points.preservealpha.preserveaspectratio.primitiveunits.r.rx.ry.radius.refx.refy.repeatcount.repeatdur.restart.result.rotate.scale.seed.shape-rendering.slope.specularconstant.specularexponent.spreadmethod.startoffset.stddeviation.stitchtiles.stop-color.stop-opacity.stroke-dasharray.stroke-dashoffset.stroke-linecap.stroke-linejoin.stroke-miterlimit.stroke-opacity.stroke.stroke-width.style.surfacescale.systemlanguage.tabindex.tablevalues.targetx.targety.transform.transform-origin.text-anchor.text-decoration.text-orientation.text-rendering.textlength.type.u1.u2.unicode.values.viewbox.visibility.version.vert-adv-y.vert-origin-x.vert-origin-y.width.word-spacing.wrap.writing-mode.xchannelselector.ychannelselector.x.x1.x2.xmlns.y.y1.y2.z.zoomandpan".split(".")), At = F(/* @__PURE__ */ "accent.accentunder.align.bevelled.close.columnalign.columnlines.columnspacing.columnspan.denomalign.depth.dir.display.displaystyle.encoding.fence.frame.height.href.id.largeop.length.linethickness.lquote.lspace.mathbackground.mathcolor.mathsize.mathvariant.maxsize.minsize.movablelimits.notation.numalign.open.rowalign.rowlines.rowspacing.rowspan.rspace.rquote.scriptlevel.scriptminsize.scriptsizemultiplier.selection.separator.separators.stretchy.subscriptshift.supscriptshift.symmetric.voffset.width.xmlns".split(".")), jt = F([
	"xlink:href",
	"xml:id",
	"xlink:title",
	"xml:space",
	"xmlns:xlink"
]), Mt = I(/{{[\w\W]*|^[\w\W]*}}/g), Nt = I(/<%[\w\W]*|^[\w\W]*%>/g), Pt = I(/\${[\w\W]*/g), Ft = I(/^data-[\-\w.\u00B7-\uFFFF]+$/), It = I(/^aria-[\-\w]+$/), Lt = I(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), Rt = I(/^(?:\w+script|data):/i), zt = I(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), Bt = I(/^html$/i), Vt = I(/^[a-z][.\w]*(-[.\w]+)+$/i), Ht = I(/<[/\w!]/g), Ut = I(/<[/\w]/g), Wt = I(/<\/no(script|embed|frames)/i), Gt = I(/\/>/i), G = {
	element: 1,
	attribute: 2,
	text: 3,
	cdataSection: 4,
	entityReference: 5,
	entityNode: 6,
	processingInstruction: 7,
	comment: 8,
	document: 9,
	documentType: 10,
	documentFragment: 11,
	notation: 12
}, Kt = function() {
	return typeof window > "u" ? null : window;
}, qt = function(e, t) {
	if (typeof e != "object" || typeof e.createPolicy != "function") return null;
	let n = null, r = "data-tt-policy-suffix";
	t && t.hasAttribute(r) && (n = t.getAttribute(r));
	let i = "dompurify" + (n ? "#" + n : "");
	try {
		return e.createPolicy(i, {
			createHTML(e) {
				return e;
			},
			createScriptURL(e) {
				return e;
			}
		});
	} catch {
		return console.warn("TrustedTypes policy " + i + " could not be created."), null;
	}
}, Jt = function() {
	return {
		afterSanitizeAttributes: [],
		afterSanitizeElements: [],
		afterSanitizeShadowDOM: [],
		beforeSanitizeAttributes: [],
		beforeSanitizeElements: [],
		beforeSanitizeShadowDOM: [],
		uponSanitizeAttribute: [],
		uponSanitizeElement: [],
		uponSanitizeShadowNode: []
	};
}, Yt = function(e, t, n, r) {
	return L(e, t) && ot(e[t]) ? H(r.base ? U(r.base) : {}, e[t], r.transform) : n;
};
function Xt() {
	let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Kt(), t = (e) => Xt(e);
	if (t.version = "3.4.12", t.removed = [], !e || !e.document || e.document.nodeType !== G.document || !e.Element) return t.isSupported = !1, t;
	let n = e.document, r = n, i = r.currentScript;
	e.DocumentFragment;
	let a = e.HTMLTemplateElement, o = e.Node, s = e.Element, c = e.NodeFilter;
	e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
	let l = e.DOMParser, u = e.trustedTypes, d = s.prototype, ee = W(d, "cloneNode"), f = W(d, "remove"), p = W(d, "nextSibling"), m = W(d, "childNodes"), h = W(d, "parentNode"), te = W(d, "shadowRoot"), g = W(d, "attributes"), _ = o && o.prototype ? W(o.prototype, "nodeType") : null, v = o && o.prototype ? W(o.prototype, "nodeName") : null;
	if (typeof a == "function") {
		let e = n.createElement("template");
		e.content && e.content.ownerDocument && (n = e.content.ownerDocument);
	}
	let y, b = "", x, ne = !1, re = 0, ie = function() {
		if (re > 0) throw _t("A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the \"DOMPurify and Trusted Types\" section of the README.");
	}, S = function(e) {
		ie(), re++;
		try {
			return y.createHTML(e);
		} finally {
			re--;
		}
	}, ae = function(e) {
		ie(), re++;
		try {
			return y.createScriptURL(e);
		} finally {
			re--;
		}
	}, oe = function() {
		return ne ||= (x = qt(u, i), !0), x;
	}, se = n, ce = se.implementation, le = se.createNodeIterator, C = se.createDocumentFragment, w = se.getElementsByTagName, ue = r.importNode, T = Jt();
	t.isSupported = typeof qe == "function" && typeof h == "function" && ce && ce.createHTMLDocument !== void 0;
	let de = Mt, fe = Nt, pe = Pt, me = Ft, he = It, ge = Rt, _e = zt, ve = Vt, ye = Lt, E = null, be = H({}, [
		...xt,
		...St,
		...Ct,
		...Tt,
		...Dt
	]), D = null, xe = H({}, [
		...Ot,
		...kt,
		...At,
		...jt
	]), O = Object.seal(Ze(null, {
		tagNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeNameCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		allowCustomizedBuiltInElements: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: !1
		}
	})), Se = null, Ce = null, k = Object.seal(Ze(null, {
		tagCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		},
		attributeCheck: {
			writable: !0,
			configurable: !1,
			enumerable: !0,
			value: null
		}
	})), we = !0, Te = !0, Ee = !1, De = !0, A = !1, j = !0, Oe = !1, ke = !1, Ae = null, je = null, Me = !1, Ne = !1, Pe = !1, Fe = !1, Ie = !0, Le = !1, Re = "user-content-", ze = !0, Be = !1, M = {}, N = null, Ve = H({}, /* @__PURE__ */ "annotation-xml.audio.colgroup.desc.foreignobject.head.iframe.math.mi.mn.mo.ms.mtext.noembed.noframes.noscript.plaintext.script.selectedcontent.style.svg.template.thead.title.video.xmp".split(".")), He = null, Ue = H({}, [
		"audio",
		"video",
		"img",
		"source",
		"image",
		"track"
	]), We = null, Ge = H({}, [
		"alt",
		"class",
		"for",
		"id",
		"label",
		"name",
		"pattern",
		"placeholder",
		"role",
		"summary",
		"title",
		"value",
		"style",
		"xmlns"
	]), Ke = "http://www.w3.org/1998/Math/MathML", Je = "http://www.w3.org/2000/svg", P = "http://www.w3.org/1999/xhtml", Ye = P, Xe = !1, Qe = null, $e = H({}, [
		Ke,
		Je,
		P
	], ct), et = F([
		"mi",
		"mo",
		"mn",
		"ms",
		"mtext"
	]), pt = H({}, et), mt = F(["annotation-xml"]), ht = H({}, mt), gt = H({}, [
		"title",
		"style",
		"font",
		"a",
		"script"
	]), R = null, B = ["application/xhtml+xml", "text/html"], V = null, vt = null, Zt = n.createElement("form"), Qt = function(e) {
		return e instanceof RegExp || e instanceof Function;
	}, K = function() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		if (vt && vt === e) return;
		(!e || typeof e != "object") && (e = {}), e = U(e), R = B.indexOf(e.PARSER_MEDIA_TYPE) === -1 ? "text/html" : e.PARSER_MEDIA_TYPE, V = R === "application/xhtml+xml" ? ct : st, E = Yt(e, "ALLOWED_TAGS", be, { transform: V }), D = Yt(e, "ALLOWED_ATTR", xe, { transform: V }), Qe = Yt(e, "ALLOWED_NAMESPACES", $e, { transform: ct }), We = Yt(e, "ADD_URI_SAFE_ATTR", Ge, {
			transform: V,
			base: Ge
		}), He = Yt(e, "ADD_DATA_URI_TAGS", Ue, {
			transform: V,
			base: Ue
		}), N = Yt(e, "FORBID_CONTENTS", Ve, { transform: V }), Se = Yt(e, "FORBID_TAGS", U({}), { transform: V }), Ce = Yt(e, "FORBID_ATTR", U({}), { transform: V }), M = L(e, "USE_PROFILES") ? e.USE_PROFILES && typeof e.USE_PROFILES == "object" ? U(e.USE_PROFILES) : e.USE_PROFILES : !1, we = e.ALLOW_ARIA_ATTR !== !1, Te = e.ALLOW_DATA_ATTR !== !1, Ee = e.ALLOW_UNKNOWN_PROTOCOLS || !1, De = e.ALLOW_SELF_CLOSE_IN_ATTR !== !1, A = e.SAFE_FOR_TEMPLATES || !1, j = e.SAFE_FOR_XML !== !1, Oe = e.WHOLE_DOCUMENT || !1, Ne = e.RETURN_DOM || !1, Pe = e.RETURN_DOM_FRAGMENT || !1, Fe = e.RETURN_TRUSTED_TYPE || !1, Me = e.FORCE_BODY || !1, Ie = e.SANITIZE_DOM !== !1, Le = e.SANITIZE_NAMED_PROPS || !1, ze = e.KEEP_CONTENT !== !1, Be = e.IN_PLACE || !1, ye = bt(e.ALLOWED_URI_REGEXP) ? e.ALLOWED_URI_REGEXP : Lt, Ye = typeof e.NAMESPACE == "string" ? e.NAMESPACE : P, pt = L(e, "MATHML_TEXT_INTEGRATION_POINTS") && e.MATHML_TEXT_INTEGRATION_POINTS && typeof e.MATHML_TEXT_INTEGRATION_POINTS == "object" ? U(e.MATHML_TEXT_INTEGRATION_POINTS) : H({}, et), ht = L(e, "HTML_INTEGRATION_POINTS") && e.HTML_INTEGRATION_POINTS && typeof e.HTML_INTEGRATION_POINTS == "object" ? U(e.HTML_INTEGRATION_POINTS) : H({}, mt);
		let t = L(e, "CUSTOM_ELEMENT_HANDLING") && e.CUSTOM_ELEMENT_HANDLING && typeof e.CUSTOM_ELEMENT_HANDLING == "object" ? U(e.CUSTOM_ELEMENT_HANDLING) : Ze(null);
		if (O = Ze(null), L(t, "tagNameCheck") && Qt(t.tagNameCheck) && (O.tagNameCheck = t.tagNameCheck), L(t, "attributeNameCheck") && Qt(t.attributeNameCheck) && (O.attributeNameCheck = t.attributeNameCheck), L(t, "allowCustomizedBuiltInElements") && typeof t.allowCustomizedBuiltInElements == "boolean" && (O.allowCustomizedBuiltInElements = t.allowCustomizedBuiltInElements), I(O), A && (Te = !1), Pe && (Ne = !0), M && (E = H({}, Dt), D = Ze(null), M.html === !0 && (H(E, xt), H(D, Ot)), M.svg === !0 && (H(E, St), H(D, kt), H(D, jt)), M.svgFilters === !0 && (H(E, Ct), H(D, kt), H(D, jt)), M.mathMl === !0 && (H(E, Tt), H(D, At), H(D, jt))), k.tagCheck = null, k.attributeCheck = null, L(e, "ADD_TAGS") && (typeof e.ADD_TAGS == "function" ? k.tagCheck = e.ADD_TAGS : ot(e.ADD_TAGS) && (E === be && (E = U(E)), H(E, e.ADD_TAGS, V))), L(e, "ADD_ATTR") && (typeof e.ADD_ATTR == "function" ? k.attributeCheck = e.ADD_ATTR : ot(e.ADD_ATTR) && (D === xe && (D = U(D)), H(D, e.ADD_ATTR, V))), L(e, "ADD_URI_SAFE_ATTR") && ot(e.ADD_URI_SAFE_ATTR) && H(We, e.ADD_URI_SAFE_ATTR, V), L(e, "FORBID_CONTENTS") && ot(e.FORBID_CONTENTS) && (N === Ve && (N = U(N)), H(N, e.FORBID_CONTENTS, V)), L(e, "ADD_FORBID_CONTENTS") && ot(e.ADD_FORBID_CONTENTS) && (N === Ve && (N = U(N)), H(N, e.ADD_FORBID_CONTENTS, V)), ze && (E["#text"] = !0), Oe && H(E, [
			"html",
			"head",
			"body"
		]), E.table && (H(E, ["tbody"]), delete Se.tbody), e.TRUSTED_TYPES_POLICY) {
			if (typeof e.TRUSTED_TYPES_POLICY.createHTML != "function") throw _t("TRUSTED_TYPES_POLICY configuration option must provide a \"createHTML\" hook.");
			if (typeof e.TRUSTED_TYPES_POLICY.createScriptURL != "function") throw _t("TRUSTED_TYPES_POLICY configuration option must provide a \"createScriptURL\" hook.");
			let t = y;
			y = e.TRUSTED_TYPES_POLICY;
			try {
				b = S("");
			} catch (e) {
				throw y = t, e;
			}
		} else e.TRUSTED_TYPES_POLICY === null ? (y = void 0, b = "") : (y === void 0 && (y = oe()), y && typeof b == "string" && (b = S("")));
		F && F(e), vt = e;
	}, $t = H({}, [
		...St,
		...Ct,
		...wt
	]), en = H({}, [...Tt, ...Et]), tn = function(e, t, n) {
		return t.namespaceURI === P ? e === "svg" : t.namespaceURI === Ke ? e === "svg" && (n === "annotation-xml" || pt[n]) : !!$t[e];
	}, q = function(e, t, n) {
		return t.namespaceURI === P ? e === "math" : t.namespaceURI === Je ? e === "math" && ht[n] : !!en[e];
	}, nn = function(e, t, n) {
		return t.namespaceURI === Je && !ht[n] || t.namespaceURI === Ke && !pt[n] ? !1 : !en[e] && (gt[e] || !$t[e]);
	}, J = function(e) {
		let t = h(e);
		(!t || !t.tagName) && (t = {
			namespaceURI: Ye,
			tagName: "template"
		});
		let n = st(e.tagName), r = st(t.tagName);
		return Qe[e.namespaceURI] ? e.namespaceURI === Je ? tn(n, t, r) : e.namespaceURI === Ke ? q(n, t, r) : e.namespaceURI === P ? nn(n, t, r) : !!(R === "application/xhtml+xml" && Qe[e.namespaceURI]) : !1;
	}, rn = function(e) {
		it(t.removed, { element: e });
		try {
			h(e).removeChild(e);
		} catch {
			if (f(e), !h(e)) throw _t("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
		}
	}, an = function(e) {
		cn(e);
		let t = m(e);
		if (t) {
			let e = [];
			tt(t, (t) => {
				it(e, t);
			}), tt(e, (e) => {
				try {
					f(e);
				} catch {}
			});
		}
		let n = g(e);
		if (n) for (let t = n.length - 1; t >= 0; --t) {
			let r = n[t], i = r && r.name;
			if (typeof i == "string") try {
				e.removeAttribute(i);
			} catch {}
		}
	}, on = function(e, n) {
		try {
			it(t.removed, {
				attribute: n.getAttributeNode(e),
				from: n
			});
		} catch {
			it(t.removed, {
				attribute: null,
				from: n
			});
		}
		if (n.removeAttribute(e), e === "is") if (Ne || Pe) try {
			rn(n);
		} catch {}
		else try {
			n.setAttribute(e, "");
		} catch {}
	}, sn = function(e) {
		let t = g(e);
		if (t) for (let n = t.length - 1; n >= 0; --n) {
			let r = t[n], i = r && r.name;
			if (!(typeof i != "string" || D[V(i)])) try {
				e.removeAttribute(i);
			} catch {}
		}
	}, cn = function(e) {
		let t = [e];
		for (; t.length > 0;) {
			let e = t.pop();
			(_ ? _(e) : e.nodeType) === G.element && sn(e);
			let n = m(e);
			if (n) for (let e = n.length - 1; e >= 0; --e) t.push(n[e]);
		}
	}, ln = function(e) {
		if (!j) return;
		let t = [e];
		for (; t.length > 0;) {
			let e = t.pop(), n = _ ? _(e) : e.nodeType;
			if (n === G.processingInstruction || n === G.comment && z(Ut, e.data)) {
				try {
					f(e);
				} catch {}
				continue;
			}
			if (n === G.element) {
				let t = e, n = V(v ? v(e) : e.nodeName);
				try {
					t.hasAttribute && t.hasAttribute("patchsrc") && t.removeAttribute("patchsrc"), t.hasAttribute && t.hasAttribute("for") && n !== "label" && n !== "output" && t.removeAttribute("for");
				} catch {}
			}
			let r = m(e);
			if (r) for (let e = r.length - 1; e >= 0; --e) t.push(r[e]);
		}
	}, un = function(e) {
		let t = null, r = null;
		if (Me) e = "<remove></remove>" + e;
		else {
			let t = lt(e, /^[\r\n\t ]+/);
			r = t && t[0];
		}
		R === "application/xhtml+xml" && Ye === P && (e = "<html xmlns=\"http://www.w3.org/1999/xhtml\"><head></head><body>" + e + "</body></html>");
		let i = y ? S(e) : e;
		if (Ye === P) try {
			t = new l().parseFromString(i, R);
		} catch {}
		if (!t || !t.documentElement) {
			t = ce.createDocument(Ye, "template", null);
			try {
				t.documentElement.innerHTML = Xe ? b : i;
			} catch {}
		}
		let a = t.body || t.documentElement;
		return e && r && a.insertBefore(n.createTextNode(r), a.childNodes[0] || null), Ye === P ? w.call(t, Oe ? "html" : "body")[0] : Oe ? t.documentElement : a;
	}, dn = function(e) {
		return le.call(e.ownerDocument || e, e, c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION, null);
	}, fn = function(e) {
		return e = ut(e, de, " "), e = ut(e, fe, " "), e = ut(e, pe, " "), e;
	}, pn = function(e) {
		e.normalize();
		let t = le.call(e.ownerDocument || e, e, c.SHOW_TEXT | c.SHOW_COMMENT | c.SHOW_CDATA_SECTION | c.SHOW_PROCESSING_INSTRUCTION, null), n = t.nextNode();
		for (; n;) n.data = fn(n.data), n = t.nextNode();
		let r = e.querySelectorAll?.call(e, "template");
		r && tt(r, (e) => {
			hn(e.content) && pn(e.content);
		});
	}, mn = function(e) {
		let t = v ? v(e) : null;
		return typeof t != "string" || V(t) !== "form" ? !1 : typeof e.nodeName != "string" || typeof e.textContent != "string" || typeof e.removeChild != "function" || e.attributes !== g(e) || typeof e.removeAttribute != "function" || typeof e.setAttribute != "function" || typeof e.namespaceURI != "string" || typeof e.insertBefore != "function" || typeof e.hasChildNodes != "function" || e.nodeType !== _(e) || e.childNodes !== m(e);
	}, hn = function(e) {
		if (!_ || typeof e != "object" || !e) return !1;
		try {
			return _(e) === G.documentFragment;
		} catch {
			return !1;
		}
	}, gn = function(e) {
		if (!_ || typeof e != "object" || !e) return !1;
		try {
			return typeof _(e) == "number";
		} catch {
			return !1;
		}
	};
	function Y(e, n, r) {
		e.length !== 0 && tt(e, (e) => {
			e.call(t, n, r, vt);
		});
	}
	let _n = function(e, t) {
		return !!(j && e.hasChildNodes() && !gn(e.firstElementChild) && z(Ht, e.textContent) && z(Ht, e.innerHTML) || j && e.namespaceURI === P && t === "style" && gn(e.firstElementChild) || e.nodeType === G.processingInstruction || j && e.nodeType === G.comment && z(Ut, e.data));
	}, vn = function(e, t) {
		if (!Se[t] && Sn(t) && (O.tagNameCheck instanceof RegExp && z(O.tagNameCheck, t) || O.tagNameCheck instanceof Function && O.tagNameCheck(t))) return !1;
		if (ze && !N[t]) {
			let t = h(e), n = m(e);
			if (n && t) {
				let r = n.length;
				for (let i = r - 1; i >= 0; --i) {
					let r = Be ? n[i] : ee(n[i], !0);
					t.insertBefore(r, p(e));
				}
			}
		}
		return rn(e), !0;
	}, yn = function(e, n) {
		if (Y(T.beforeSanitizeElements, e, null), e !== n && h(e) === null) return !0;
		if (mn(e)) return rn(e), !0;
		let r = V(v ? v(e) : e.nodeName);
		if (Y(T.uponSanitizeElement, e, {
			tagName: r,
			allowedTags: E
		}), e !== n && h(e) === null) return !0;
		if (_n(e, r)) return rn(e), !0;
		if (Se[r] || !(k.tagCheck instanceof Function && k.tagCheck(r)) && !E[r]) {
			let t = vn(e, r);
			return t === !1 && Y(T.afterSanitizeElements, e, null), t;
		}
		if ((_ ? _(e) : e.nodeType) === G.element && !J(e) || (r === "noscript" || r === "noembed" || r === "noframes") && z(Wt, e.innerHTML)) return rn(e), !0;
		if (A && e.nodeType === G.text) {
			let n = fn(e.textContent);
			e.textContent !== n && (it(t.removed, { element: e.cloneNode() }), e.textContent = n);
		}
		return Y(T.afterSanitizeElements, e, null), !1;
	}, bn = function(e, t, r) {
		if (Ce[t] || j && t === "patchsrc" || j && t === "for" && e !== "label" && e !== "output" || Ie && (t === "id" || t === "name") && (r in n || r in Zt)) return !1;
		let i = D[t] || k.attributeCheck instanceof Function && k.attributeCheck(t, e);
		if (!(Te && z(me, t)) && !(we && z(he, t))) {
			if (!i) {
				if (!(Sn(e) && (O.tagNameCheck instanceof RegExp && z(O.tagNameCheck, e) || O.tagNameCheck instanceof Function && O.tagNameCheck(e)) && (O.attributeNameCheck instanceof RegExp && z(O.attributeNameCheck, t) || O.attributeNameCheck instanceof Function && O.attributeNameCheck(t, e)) || t === "is" && O.allowCustomizedBuiltInElements && (O.tagNameCheck instanceof RegExp && z(O.tagNameCheck, r) || O.tagNameCheck instanceof Function && O.tagNameCheck(r)))) return !1;
			} else if (!We[t] && !z(ye, ut(r, _e, "")) && !((t === "src" || t === "xlink:href" || t === "href") && e !== "script" && dt(r, "data:") === 0 && He[e]) && !(Ee && !z(ge, ut(r, _e, ""))) && r) return !1;
		}
		return !0;
	}, xn = H({}, [
		"annotation-xml",
		"color-profile",
		"font-face",
		"font-face-format",
		"font-face-name",
		"font-face-src",
		"font-face-uri",
		"missing-glyph"
	]), Sn = function(e) {
		return !xn[st(e)] && z(ve, e);
	}, Cn = function(e, t, n, r) {
		if (y && typeof u == "object" && typeof u.getAttributeType == "function" && !n) switch (u.getAttributeType(e, t)) {
			case "TrustedHTML": return S(r);
			case "TrustedScriptURL": return ae(r);
		}
		return r;
	}, wn = function(e, n, r, i) {
		try {
			r ? e.setAttributeNS(r, n, i) : e.setAttribute(n, i), mn(e) ? rn(e) : rt(t.removed);
		} catch {
			on(n, e);
		}
	}, Tn = function(e) {
		Y(T.beforeSanitizeAttributes, e, null);
		let t = e.attributes;
		if (!t || mn(e)) return;
		let n = {
			attrName: "",
			attrValue: "",
			keepAttr: !0,
			allowedAttributes: D,
			forceKeepAttr: void 0
		}, r = t.length, i = V(e.nodeName);
		for (; r--;) {
			let a = t[r], o = a.name, s = a.namespaceURI, c = a.value, l = V(o), u = c, d = o === "value" ? u : ft(u);
			if (n.attrName = l, n.attrValue = d, n.keepAttr = !0, n.forceKeepAttr = void 0, Y(T.uponSanitizeAttribute, e, n), d = n.attrValue, Le && (l === "id" || l === "name") && dt(d, Re) !== 0 && (on(o, e), d = Re + d), j && z(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, d)) {
				on(o, e);
				continue;
			}
			if (l === "attributename" && lt(d, "href")) {
				on(o, e);
				continue;
			}
			if (!n.forceKeepAttr) {
				if (!n.keepAttr) {
					on(o, e);
					continue;
				}
				if (!De && z(Gt, d)) {
					on(o, e);
					continue;
				}
				if (A && (d = fn(d)), !bn(i, l, d)) {
					on(o, e);
					continue;
				}
				d = Cn(i, l, s, d), d !== u && wn(e, o, s, d);
			}
		}
		Y(T.afterSanitizeAttributes, e, null);
	}, En = function(e) {
		let t = null, n = dn(e);
		for (Y(T.beforeSanitizeShadowDOM, e, null); t = n.nextNode();) if (Y(T.uponSanitizeShadowNode, t, null), yn(t, e), Tn(t), hn(t.content) && En(t.content), (_ ? _(t) : t.nodeType) === G.element) {
			let e = te(t);
			hn(e) && (Dn(e), En(e));
		}
		Y(T.afterSanitizeShadowDOM, e, null);
	}, Dn = function(e) {
		let t = [{
			node: e,
			shadow: null
		}];
		for (; t.length > 0;) {
			let e = t.pop();
			if (e.shadow) {
				En(e.shadow);
				continue;
			}
			let n = e.node, r = (_ ? _(n) : n.nodeType) === G.element, i = m(n);
			if (i) for (let e = i.length - 1; e >= 0; --e) t.push({
				node: i[e],
				shadow: null
			});
			if (r) {
				let e = v ? v(n) : null;
				if (typeof e == "string" && V(e) === "template") {
					let e = n.content;
					hn(e) && t.push({
						node: e,
						shadow: null
					});
				}
			}
			if (r) {
				let e = te(n);
				hn(e) && t.push({
					node: null,
					shadow: e
				}, {
					node: e,
					shadow: null
				});
			}
		}
	};
	return t.sanitize = function(e) {
		let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = null, a = null, o = null, s = null;
		if (Xe = !e, Xe && (e = "<!-->"), typeof e != "string" && !gn(e) && (e = yt(e), typeof e != "string")) throw _t("dirty is not a string, aborting");
		if (!t.isSupported) return e;
		ke ? (E = Ae, D = je) : K(n), (T.uponSanitizeElement.length > 0 || T.uponSanitizeAttribute.length > 0) && (E = U(E)), T.uponSanitizeAttribute.length > 0 && (D = U(D)), t.removed = [];
		let c = Be && typeof e != "string" && gn(e);
		if (c) {
			ln(e);
			let t = v ? v(e) : e.nodeName;
			if (typeof t == "string") {
				let n = V(t);
				if (!E[n] || Se[n]) throw an(e), _t("root node is forbidden and cannot be sanitized in-place");
			}
			if (mn(e)) throw an(e), _t("root node is clobbered and cannot be sanitized in-place");
			try {
				Dn(e);
			} catch (t) {
				throw an(e), t;
			}
		} else if (gn(e)) i = un("<!---->"), a = i.ownerDocument.importNode(e, !0), a.nodeType === G.element && a.nodeName === "BODY" || a.nodeName === "HTML" ? i = a : i.appendChild(a), Dn(a);
		else {
			if (!Ne && !A && !Oe && e.indexOf("<") === -1) return y && Fe ? S(e) : e;
			if (i = un(e), !i) return Ne ? null : Fe ? b : "";
		}
		i && Me && rn(i.firstChild);
		let l = c ? e : i, u = dn(l);
		try {
			for (; o = u.nextNode();) yn(o, l), Tn(o), hn(o.content) && En(o.content);
		} catch (n) {
			throw c && (an(e), tt(t.removed, (e) => {
				e.element && cn(e.element);
			})), n;
		}
		if (c) return tt(t.removed, (e) => {
			e.element && cn(e.element);
		}), A && pn(e), e;
		if (Ne) {
			if (A && pn(i), Pe) for (s = C.call(i.ownerDocument); i.firstChild;) s.appendChild(i.firstChild);
			else s = i;
			return (D.shadowroot || D.shadowrootmode) && (s = ue.call(r, s, !0)), s;
		}
		let d = Oe ? i.outerHTML : i.innerHTML;
		return Oe && E["!doctype"] && i.ownerDocument && i.ownerDocument.doctype && i.ownerDocument.doctype.name && z(Bt, i.ownerDocument.doctype.name) && (d = "<!DOCTYPE " + i.ownerDocument.doctype.name + ">\n" + d), A && (d = fn(d)), y && Fe ? S(d) : d;
	}, t.setConfig = function() {
		let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		K(e), ke = !0, Ae = E, je = D;
	}, t.clearConfig = function() {
		vt = null, ke = !1, Ae = null, je = null, y = x, b = "";
	}, t.isValidAttribute = function(e, t, n) {
		vt || K({});
		let r = V(e), i = V(t);
		return bn(r, i, n);
	}, t.addHook = function(e, t) {
		typeof t == "function" && L(T, e) && it(T[e], t);
	}, t.removeHook = function(e, t) {
		if (L(T, e)) {
			if (t !== void 0) {
				let n = nt(T[e], t);
				return n === -1 ? void 0 : at(T[e], n, 1)[0];
			}
			return rt(T[e]);
		}
	}, t.removeHooks = function(e) {
		L(T, e) && (T[e] = []);
	}, t.removeAllHooks = function() {
		T = Jt();
	}, t;
}
var Zt = Xt();
//#endregion
//#region ../../node_modules/.pnpm/marked@18.0.13/node_modules/marked/lib/marked.esm.js
function Qt() {
	return {
		async: !1,
		breaks: !1,
		extensions: null,
		gfm: !0,
		hooks: null,
		pedantic: !1,
		renderer: null,
		silent: !1,
		tokenizer: null,
		walkTokens: null
	};
}
var K = Qt();
function $t(e) {
	K = e;
}
var en = { exec: () => null };
function tn(e) {
	let t = [];
	return (n) => {
		let r = Math.max(0, Math.min(3, n - 1)), i = t[r];
		return i || (i = e(r), t[r] = i), i;
	};
}
function q(e, t = "") {
	let n = typeof e == "string" ? e : e.source, r = {
		replace: (e, t) => {
			let i = typeof t == "string" ? t : t.source;
			return i = i.replace(J.caret, "$1"), n = n.replace(e, i), r;
		},
		getRegex: () => new RegExp(n, t)
	};
	return r;
}
var nn = ((e = "") => {
	try {
		return !!RegExp("(?<=1)(?<!1)" + e);
	} catch {
		return !1;
	}
})(), J = {
	codeRemoveIndent: /^(?: {0,3}\t| {1,4})/gm,
	outputLinkReplace: /\\([\[\]])/g,
	indentCodeCompensation: /^(\s+)(?:```)/,
	beginningSpace: /^\s+/,
	endingHash: /#$/,
	startingSpaceChar: /^ /,
	endingSpaceChar: / $/,
	endingSpaceTabChar: /[ \t]$/,
	nonSpaceChar: /[^ ]/,
	newLineCharGlobal: /\n/g,
	tabCharGlobal: /\t/g,
	multipleSpaceGlobal: /\s+/g,
	blankLine: /^[ \t]*$/,
	doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
	blockquoteStart: /^ {0,3}>/,
	blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
	blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
	listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
	listIsTask: /^\[[ xX]\] +\S/,
	listReplaceTask: /^\[[ xX]\] +/,
	listTaskCheckbox: /\[[ xX]\]/,
	anyLine: /\n.*\n/,
	hrefBrackets: /^<(.*)>$/,
	tableDelimiter: /[:|]/,
	tableAlignChars: /^\||\| *$/g,
	tableRowBlankLine: /\n[ \t]*$/,
	tableAlignRight: /^ *-+: *$/,
	tableAlignCenter: /^ *:-+: *$/,
	tableAlignLeft: /^ *:-+ *$/,
	startATag: /^<a /i,
	endATag: /^<\/a>/i,
	startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
	endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
	startAngleBracket: /^</,
	endAngleBracket: />$/,
	pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
	unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
	escapeTest: /[&<>"']/,
	escapeReplace: /[&<>"']/g,
	escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
	escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
	caret: /(^|[^\[])\^/g,
	percentDecode: /%25/g,
	findPipe: /\|/g,
	splitPipe: / \|/,
	slashPipe: /\\\|/g,
	carriageReturn: /\r\n|\r/g,
	spaceLine: /^ +$/gm,
	notSpaceStart: /^\S*/,
	endingNewline: /\n$/,
	listItemRegex: (e) => RegExp(`^( {0,3}${e})((?:[	 ][^\\n]*)?(?:\\n|$))`),
	nextBulletRegex: tn((e) => RegExp(`^ {0,${e}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`)),
	hrRegex: tn((e) => RegExp(`^ {0,${e}}((?:-[ 	]*){3,}|(?:_[ 	]*){3,}|(?:\\*[ 	]*){3,})(?:\\n+|$)`)),
	fencesBeginRegex: tn((e) => RegExp(`^ {0,${e}}(?:\`\`\`|~~~)`)),
	headingBeginRegex: tn((e) => RegExp(`^ {0,${e}}#`)),
	htmlBeginRegex: tn((e) => RegExp(`^ {0,${e}}(?:</?(?:${_n})(?: +|$|/?>)|<(?:script|pre|style|textarea|!--))`, "i")),
	blockquoteBeginRegex: tn((e) => RegExp(`^ {0,${e}}>`))
}, rn = /^(?:[ \t]*(?:\n|$))+/, an = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, on = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, sn = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, cn = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, ln = / {0,3}(?:[*+-]|\d{1,9}[.)])/, un = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, dn = q(un).replace(/bull/g, ln).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}(?:\s|$)/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), fn = q(un).replace(/bull/g, ln).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}(?:\s|$)/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), pn = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table|[ \t]+\n)[^\n]+)*)/, mn = /^[^\n]+/, hn = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, gn = q(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", hn).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), Y = q(/^(bull)([ \t][^\n]*?)?(?:\n|$)/).replace(/bull/g, ln).getRegex(), _n = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", vn = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, yn = q("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n*|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>[^\\n]*\\n*|$)|<![A-Z][\\s\\S]*?(?:>[^\\n]*\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>[^\\n]*\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][a-z0-9-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][a-z0-9-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", vn).replace("tag", _n).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), bn = (e) => q(pn).replace("hr", sn).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", e).replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _n).getRegex(), xn = bn(/ {0,3}(?:[*+-]|1[.)])[ \t]+[^ \t\n]/), Sn = bn(/ {0,3}(?:[*+-]|\d{1,9}[.)])(?:[ \t]|\n|$)/), Cn = {
	blockquote: q(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", Sn).getRegex(),
	code: an,
	def: gn,
	fences: on,
	heading: cn,
	hr: sn,
	html: yn,
	lheading: dn,
	list: Y,
	newline: rn,
	paragraph: xn,
	table: en,
	text: mn
}, wn = q("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", sn).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _n).getRegex(), Tn = {
	...Cn,
	lheading: fn,
	table: wn,
	paragraph: q(pn).replace("hr", sn).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", wn).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]+[^ \\t\\n]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", _n).getRegex()
}, En = {
	...Cn,
	html: q("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace("comment", vn).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
	def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
	heading: /^(#{1,6})(.*)(?:\n+|$)/,
	fences: en,
	lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
	paragraph: q(pn).replace("hr", sn).replace("heading", " *#{1,6} *[^\n]").replace("lheading", dn).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, Dn = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, On = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, kn = /^( {2,}|\\)\n(?!\s*$)[ \t]*/, An = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, jn = /[\p{P}\p{S}]/u, Mn = /[\s\p{P}\p{S}]/u, Nn = /[^\s\p{P}\p{S}]/u, Pn = q(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, Mn).getRegex(), Fn = /[\p{Pi}\p{Ps}"']/u, In = /(?!~)[\p{P}\p{S}]/u, Ln = /(?!~)[\s\p{P}\p{S}]/u, Rn = /(?:[^\s\p{P}\p{S}]|~)/u, zn = q(/link|precode-code|html/, "g").replace("link", /\[(?:[^\[\]`]|(?<a>`+)[^`]+\k<a>(?!`))*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)/).replace("precode-", nn ? "(?<!`)()" : "(^^|[^`])").replace("code", /(?<b>`+)[^`]+\k<b>(?!`)/).replace("html", /<(?! )[^<>]*?>/).getRegex(), Bn = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, Vn = q(Bn, "u").replace(/punct/g, jn).getRegex(), Hn = q(Bn, "u").replace(/punct/g, In).getRegex(), Un = q(/^(?:\*+(?:((?!\*)(?!openQuote)punct)|([^\s*]))?)|^_+(?:((?!_)(?!openQuote)punct)|([^\s_]))?/, "u").replace(/openQuote/g, Fn).replace(/punct/g, jn).getRegex(), Wn = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", Gn = q(Wn, "gu").replace(/notPunctSpace/g, Nn).replace(/punctSpace/g, Mn).replace(/punct/g, jn).getRegex(), Kn = q(Wn, "gu").replace(/notPunctSpace/g, Rn).replace(/punctSpace/g, Ln).replace(/punct/g, In).getRegex(), qn = q("^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)[\\s](\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|(?:(?!\\*)punct|notPunctSpace)(\\*+)(?!\\*)(?=notPunctSpace)", "gu").replace(/notPunctSpace/g, Nn).replace(/punctSpace/g, Mn).replace(/punct/g, jn).getRegex(), Jn = q("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, Nn).replace(/punctSpace/g, Mn).replace(/punct/g, jn).getRegex(), Yn = q("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)[\\s](_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)|(?:(?!_)punct|notPunctSpace)(_+)(?!_)(?=notPunctSpace)", "gu").replace(/notPunctSpace/g, Nn).replace(/punctSpace/g, Mn).replace(/punct/g, jn).getRegex(), Xn = q(/^~~?(?:((?!~)punct)|[^\s~])/, "u").replace(/punct/g, jn).getRegex(), Zn = q("^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)", "gu").replace(/notPunctSpace/g, Nn).replace(/punctSpace/g, Mn).replace(/punct/g, jn).getRegex(), Qn = q(/\\(punct)/, "gu").replace(/punct/g, jn).getRegex(), $n = q(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), er = q(vn).replace("(?:-->|$)", "-->").getRegex(), tr = q("^comment|^</[a-zA-Z][a-zA-Z0-9-]*\\s*>|^<[a-zA-Z][a-zA-Z0-9-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", er).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), nr = /\[(?:\\[\s\S]|[^\[\]\\])*\]/, rr = q(/(?:\[(?:brackets|\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/).replace("brackets", nr).getRegex(), ir = q(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?\s*\)/).replace("label", rr).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]+|(?=\))/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), ar = q(/^!?\[(label)\]\[(ref)\]/).replace("label", rr).replace("ref", hn).getRegex(), or = q(/^!?\[(ref)\](?:\[\])?/).replace("ref", hn).getRegex(), sr = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\]){1,999}/, cr = q(/(?:[^\[\]\\`]*(?:\[(?:brackets|\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\]))){0,999}?[^\[\]\\`]*?/).replace("brackets", nr).getRegex(), lr = q("reflink|nolink(?!\\()", "g").replace("reflink", q(/^!?\[(label)\]\[(ref)\]/).replace("label", cr).replace("ref", sr).getRegex()).replace("nolink", q(/^!?\[(ref)\](?:\[\])?/).replace("ref", sr).getRegex()).getRegex(), ur = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, dr = {
	_backpedal: en,
	anyPunctuation: Qn,
	autolink: $n,
	blockSkip: zn,
	br: kn,
	code: On,
	del: en,
	delLDelim: en,
	delRDelim: en,
	emStrongLDelim: Vn,
	emStrongRDelimAst: Gn,
	emStrongRDelimUnd: Jn,
	escape: Dn,
	link: ir,
	nolink: or,
	punctuation: Pn,
	reflink: ar,
	reflinkSearch: lr,
	tag: tr,
	text: An,
	url: en
}, fr = {
	...dr,
	emStrongLDelim: Un,
	emStrongRDelimAst: qn,
	emStrongRDelimUnd: Yn,
	link: q(/^!?\[(label)\]\((.*?)\)/).replace("label", rr).getRegex(),
	reflink: q(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", rr).getRegex()
}, pr = {
	...dr,
	emStrongRDelimAst: Kn,
	emStrongLDelim: Hn,
	delLDelim: Xn,
	delRDelim: Zn,
	url: q(/^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace("protocol", ur).replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![\w-])/).getRegex(),
	_backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
	del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
	text: q(/^(`+|~+|[^`~])(?:(?=[`~])|(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/).replace("protocol", ur).getRegex()
}, mr = {
	...pr,
	br: q(kn).replace("{2,}", "*").getRegex(),
	text: q(pr.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, hr = {
	normal: Cn,
	gfm: Tn,
	pedantic: En
}, gr = {
	normal: dr,
	gfm: pr,
	breaks: mr,
	pedantic: fr
}, _r = {
	"&": "&amp;",
	"<": "&lt;",
	">": "&gt;",
	"\"": "&quot;",
	"'": "&#39;"
}, vr = (e) => _r[e];
function X(e, t) {
	if (t) {
		if (J.escapeTest.test(e)) return e.replace(J.escapeReplace, vr);
	} else if (J.escapeTestNoEncode.test(e)) return e.replace(J.escapeReplaceNoEncode, vr);
	return e;
}
function yr(e) {
	try {
		e = encodeURI(e).replace(J.percentDecode, "%");
	} catch {
		return null;
	}
	return e;
}
function br(e, t) {
	let n = e.replace(J.findPipe, (e, t, n) => {
		let r = !1, i = t;
		for (; --i >= 0 && n[i] === "\\";) r = !r;
		return r ? "|" : " |";
	}).split(J.splitPipe), r = 0;
	if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), t) if (n.length > t) n.splice(t);
	else for (; n.length < t;) n.push("");
	for (; r < n.length; r++) n[r] = n[r].trim().replace(J.slashPipe, "|");
	return n;
}
function xr(e, t, n) {
	let r = e.length;
	if (r === 0) return "";
	let i = 0;
	for (; i < r;) {
		let a = e.charAt(r - i - 1);
		if (a === t && !n) i++;
		else if (a !== t && n) i++;
		else break;
	}
	return e.slice(0, r - i);
}
function Sr(e) {
	let t = e.split("\n"), n = t.length - 1;
	for (; n >= 0 && J.blankLine.test(t[n]);) n--;
	return t.length - n <= 2 ? e : t.slice(0, n + 1).join("\n");
}
function Cr(e) {
	return e.toLowerCase().toUpperCase().toLowerCase();
}
function wr(e, t) {
	if (e.indexOf(t[1]) === -1) return -1;
	let n = 0;
	for (let r = 0; r < e.length; r++) if (e[r] === "\\") r++;
	else if (e[r] === t[0]) n++;
	else if (e[r] === t[1] && (n--, n < 0)) return r;
	return n > 0 ? -2 : -1;
}
function Tr(e, t = 0) {
	let n = t, r = "";
	for (let t of e) if (t === "	") {
		let e = 4 - n % 4;
		r += " ".repeat(e), n += e;
	} else r += t, n++;
	return r;
}
function Er(e, t, n, r, i) {
	let a = t.href, o = t.title || null, s = e[1].replace(i.other.outputLinkReplace, "$1"), c = e[0].charAt(0) === "!";
	r.state.inLink = !0;
	let l = r.state.linkEmitted, u = r.state.inRawBlock;
	r.state.linkEmitted = !1;
	let d = r.inlineTokens(s), ee = r.state.linkEmitted;
	if (r.state.linkEmitted = l, r.state.inLink = !1, !c) {
		if (ee) {
			r.state.inRawBlock = u;
			return;
		}
		r.state.linkEmitted = !0;
	}
	return {
		type: c ? "image" : "link",
		raw: n,
		href: a,
		title: o,
		text: s,
		tokens: d
	};
}
function Dr(e, t, n) {
	let r = e.match(n.other.indentCodeCompensation);
	if (r === null) return t;
	let i = r[1];
	return t.split("\n").map((e) => {
		let t = e.match(n.other.beginningSpace);
		if (t === null) return e;
		let [r] = t;
		return e.slice(Math.min(r.length, i.length));
	}).join("\n");
}
function Or(e, t, n, r) {
	if (!t.includes("<")) return !1;
	for (let i = 0; i < t.length; i++) {
		if (t[i] === "\\") {
			i++;
			continue;
		}
		if (t[i] === "`") {
			let e = r.inline.code.exec(t.slice(i));
			if (e) {
				i += e[0].length - 1;
				continue;
			}
		}
		if (t[i] !== "<") continue;
		let a = e.slice(n + i), o = r.inline.tag.exec(a) || r.inline.autolink.exec(a);
		if (o) {
			if (o[0].length > t.length - i) return !0;
			i += o[0].length - 1;
		}
	}
	return !1;
}
var kr = class {
	options;
	rules;
	lexer;
	constructor(e) {
		this.options = e || K;
	}
	space(e) {
		let t = this.rules.block.newline.exec(e);
		if (t && t[0].length > 0) return {
			type: "space",
			raw: t[0]
		};
	}
	code(e) {
		let t = this.rules.block.code.exec(e);
		if (t) {
			let e = this.options.pedantic ? t[0] : Sr(t[0]);
			return {
				type: "code",
				raw: e,
				codeBlockStyle: "indented",
				text: e.replace(this.rules.other.codeRemoveIndent, "")
			};
		}
	}
	fences(e) {
		let t = this.rules.block.fences.exec(e);
		if (t) {
			let e = t[0], n = Dr(e, t[3] || "", this.rules);
			return {
				type: "code",
				raw: e,
				lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
				text: n
			};
		}
	}
	heading(e) {
		let t = this.rules.block.heading.exec(e);
		if (t) {
			let e = t[2].trim();
			if (this.rules.other.endingHash.test(e)) {
				let t = xr(e, "#");
				(this.options.pedantic || !t || this.rules.other.endingSpaceTabChar.test(t)) && (e = t.trim());
			}
			return {
				type: "heading",
				raw: xr(t[0], "\n"),
				depth: t[1].length,
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	hr(e) {
		let t = this.rules.block.hr.exec(e);
		if (t) return {
			type: "hr",
			raw: xr(t[0], "\n")
		};
	}
	blockquote(e) {
		let t = this.rules.block.blockquote.exec(e);
		if (t) {
			let e = xr(t[0], "\n").split("\n"), n = "", r = "", i = [];
			for (; e.length > 0;) {
				let t = !1, a = [], o;
				for (o = 0; o < e.length; o++) if (this.rules.other.blockquoteStart.test(e[o])) a.push(e[o]), t = !0;
				else if (!t) a.push(e[o]);
				else break;
				e = e.slice(o);
				let s = a.join("\n"), c = s.replace(this.rules.other.blockquoteSetextReplace, "\n    $1").replace(this.rules.other.blockquoteSetextReplace2, "");
				n = n ? `${n}
${s}` : s, r = r ? `${r}
${c}` : c;
				let l = this.lexer.state.top;
				if (this.lexer.state.top = !0, this.lexer.blockTokens(c, i, !0), this.lexer.state.top = l, e.length === 0) break;
				let u = i.at(-1);
				if (u?.type === "code") break;
				if (u?.type === "blockquote") {
					let t = u, a = e.join("\n"), o = t.raw + "\n" + a.replace(this.rules.other.blockquoteSetextReplace2, ""), s = this.blockquote(o);
					i[i.length - 1] = s, n = `${n}
${a}`, r = r.substring(0, r.length - t.text.length) + s.text;
					break;
				} else if (u?.type === "list") {
					let t = u, a = t.raw + "\n" + e.join("\n"), o = this.list(a);
					i[i.length - 1] = o, n = n.substring(0, n.length - u.raw.length) + o.raw, r = r.substring(0, r.length - t.raw.length) + o.raw, e = a.substring(i.at(-1).raw.length).split("\n");
					continue;
				}
			}
			return {
				type: "blockquote",
				raw: n,
				tokens: i,
				text: r
			};
		}
	}
	list(e) {
		let t = this.rules.block.list.exec(e);
		if (t) {
			let n = t[1].trim(), r = n.length > 1, i = {
				type: "list",
				raw: "",
				ordered: r,
				start: r ? +n.slice(0, -1) : "",
				loose: !1,
				items: []
			};
			n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : "[*+-]");
			let a = this.rules.other.listItemRegex(n), o = !1;
			for (; e;) {
				let n = !1, r = "", s = "";
				if (!(t = a.exec(e)) || this.rules.block.hr.test(e)) break;
				r = t[0], e = e.substring(r.length);
				let c = Tr(t[2].split("\n", 1)[0], t[1].length), l = e.split("\n", 1)[0], u = !c.trim(), d = 0;
				if (this.options.pedantic ? (d = 2, s = c.trimStart()) : u ? d = t[1].length + 1 : (d = c.search(this.rules.other.nonSpaceChar), d = d > 4 ? 1 : d, s = c.slice(d), d += t[1].length), u && this.rules.other.blankLine.test(l) && (r += l + "\n", e = e.substring(l.length + 1), n = !0), !n) {
					let t = this.rules.other.nextBulletRegex(d), n = this.rules.other.hrRegex(d), i = this.rules.other.fencesBeginRegex(d), a = this.rules.other.headingBeginRegex(d), o = this.rules.other.htmlBeginRegex(d), ee = this.rules.other.blockquoteBeginRegex(d);
					for (; e;) {
						let f = e.split("\n", 1)[0], p;
						if (l = f, this.options.pedantic ? (l = l.replace(this.rules.other.listReplaceNesting, "  "), p = l) : p = l.replace(this.rules.other.tabCharGlobal, "    "), i.test(l) || a.test(l) || o.test(l) || ee.test(l) || t.test(l) || n.test(l)) break;
						if (p.search(this.rules.other.nonSpaceChar) >= d || !l.trim()) s += "\n" + p.slice(d);
						else {
							if (u || c.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || i.test(c) || a.test(c) || n.test(c)) break;
							s += "\n" + l;
						}
						u = !l.trim(), r += f + "\n", e = e.substring(f.length + 1), c = p.slice(d);
					}
				}
				i.loose || (o ? i.loose = !0 : this.rules.other.doubleBlankLine.test(r) && (o = !0)), i.items.push({
					type: "list_item",
					raw: r,
					task: !!this.options.gfm && this.rules.other.listIsTask.test(s),
					loose: !1,
					text: s,
					tokens: []
				}), i.raw += r;
			}
			let s = i.items.at(-1);
			if (s) s.raw = s.raw.trimEnd(), s.text = s.text.trimEnd();
			else return;
			i.raw = i.raw.trimEnd();
			for (let e of i.items) if (this.lexer.state.top = !1, e.tokens = this.lexer.blockTokens(e.text, []), !i.loose) {
				let t = e.tokens.filter((e) => e.type === "space");
				i.loose = t.length > 0 && t.some((e) => this.rules.other.anyLine.test(e.raw));
			}
			for (let e of i.items) {
				let t = e.tokens[0];
				if (e.task && (t?.type === "text" || t?.type === "paragraph")) {
					e.text = e.text.replace(this.rules.other.listReplaceTask, ""), t.raw = t.raw.replace(this.rules.other.listReplaceTask, ""), t.text = t.text.replace(this.rules.other.listReplaceTask, "");
					for (let e = this.lexer.inlineQueue.length - 1; e >= 0; e--) if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[e].src)) {
						this.lexer.inlineQueue[e].src = this.lexer.inlineQueue[e].src.replace(this.rules.other.listReplaceTask, "");
						break;
					}
					let n = this.rules.other.listTaskCheckbox.exec(e.raw);
					if (n) {
						let t = {
							type: "checkbox",
							raw: n[0] + " ",
							checked: n[0] !== "[ ]"
						};
						e.checked = t.checked, i.loose ? e.tokens[0] && ["paragraph", "text"].includes(e.tokens[0].type) && "tokens" in e.tokens[0] && e.tokens[0].tokens ? (e.tokens[0].raw = t.raw + e.tokens[0].raw, e.tokens[0].text = t.raw + e.tokens[0].text, e.tokens[0].tokens.unshift(t)) : e.tokens.unshift({
							type: "paragraph",
							raw: t.raw,
							text: t.raw,
							tokens: [t]
						}) : e.tokens.unshift(t);
					}
				} else e.task &&= !1;
			}
			if (i.loose) for (let e of i.items) {
				e.loose = !0;
				for (let t of e.tokens) t.type === "text" && (t.type = "paragraph");
			}
			return i;
		}
	}
	html(e) {
		let t = this.rules.block.html.exec(e);
		if (t) {
			let e = Sr(t[0]);
			return {
				type: "html",
				block: !0,
				raw: e,
				pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
				text: e
			};
		}
	}
	def(e) {
		let t = this.rules.block.def.exec(e);
		if (t) {
			let e = Cr(t[1]).replace(this.rules.other.multipleSpaceGlobal, " "), n = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", r = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
			return {
				type: "def",
				tag: e,
				raw: xr(t[0], "\n"),
				href: n,
				title: r
			};
		}
	}
	table(e) {
		let t = this.rules.block.table.exec(e);
		if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
		let n = br(t[1]), r = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), i = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split("\n") : [], a = {
			type: "table",
			raw: xr(t[0], "\n"),
			header: [],
			align: [],
			rows: []
		};
		if (n.length === r.length) {
			for (let e of r) this.rules.other.tableAlignRight.test(e) ? a.align.push("right") : this.rules.other.tableAlignCenter.test(e) ? a.align.push("center") : this.rules.other.tableAlignLeft.test(e) ? a.align.push("left") : a.align.push(null);
			for (let e = 0; e < n.length; e++) a.header.push({
				text: n[e],
				tokens: this.lexer.inline(n[e]),
				header: !0,
				align: a.align[e]
			});
			for (let e of i) a.rows.push(br(e, a.header.length).map((e, t) => ({
				text: e,
				tokens: this.lexer.inline(e),
				header: !1,
				align: a.align[t]
			})));
			return a;
		}
	}
	lheading(e) {
		let t = this.rules.block.lheading.exec(e);
		if (t) {
			let e = t[1].trim();
			return {
				type: "heading",
				raw: xr(t[0], "\n"),
				depth: t[2].charAt(0) === "=" ? 1 : 2,
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	paragraph(e) {
		let t = this.rules.block.paragraph.exec(e);
		if (t) {
			let e = t[1].charAt(t[1].length - 1) === "\n" ? t[1].slice(0, -1) : t[1];
			return {
				type: "paragraph",
				raw: t[0],
				text: e,
				tokens: this.lexer.inline(e)
			};
		}
	}
	text(e) {
		let t = this.rules.block.text.exec(e);
		if (t) return {
			type: "text",
			raw: t[0],
			text: t[0],
			tokens: this.lexer.inline(t[0])
		};
	}
	escape(e) {
		let t = this.rules.inline.escape.exec(e);
		if (t) return {
			type: "escape",
			raw: t[0],
			text: t[1]
		};
	}
	tag(e) {
		let t = this.rules.inline.tag.exec(e);
		if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
			type: "html",
			raw: t[0],
			inLink: this.lexer.state.inLink,
			inRawBlock: this.lexer.state.inRawBlock,
			block: !1,
			text: t[0]
		};
	}
	link(e) {
		let t = this.rules.inline.link.exec(e);
		if (t) {
			let n = t[0].charAt(0) === "!" ? 2 : 1;
			if (!this.options.pedantic && Or(e, t[1], n, this.rules)) return;
			let r = t[2].trim();
			if (!this.options.pedantic && this.rules.other.startAngleBracket.test(r)) {
				if (!this.rules.other.endAngleBracket.test(r)) return;
				let e = xr(r.slice(0, -1), "\\");
				if ((r.length - e.length) % 2 == 0) return;
			} else {
				let e = wr(t[2], "()");
				if (e === -2) return;
				if (e > -1) {
					let n = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + e;
					t[2] = t[2].substring(0, e), t[0] = t[0].substring(0, n).trim(), t[3] = "";
				}
			}
			let i = t[2], a = "";
			if (this.options.pedantic) {
				let e = this.rules.other.pedanticHrefTitle.exec(i);
				e && (i = e[1], a = e[3]);
			} else a = t[3] ? t[3].slice(1, -1) : "";
			return i = i.trim(), this.rules.other.startAngleBracket.test(i) && (i = this.options.pedantic && !this.rules.other.endAngleBracket.test(r) ? i.slice(1) : i.slice(1, -1)), Er(t, {
				href: i && i.replace(this.rules.inline.anyPunctuation, "$1"),
				title: a && a.replace(this.rules.inline.anyPunctuation, "$1")
			}, t[0], this.lexer, this.rules);
		}
	}
	reflink(e, t) {
		let n;
		if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
			let r = n[0].charAt(0) === "!" ? 2 : 1;
			if (!this.options.pedantic && Or(e, n[1], r, this.rules)) return;
			let i = t[Cr((n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " "))];
			if (!i) {
				let e = n[0].charAt(0);
				return {
					type: "text",
					raw: e,
					text: e
				};
			}
			return Er(n, i, n[0], this.lexer, this.rules);
		}
	}
	emStrong(e, t, n = "") {
		let r = this.rules.inline.emStrongLDelim.exec(e);
		if (!(!r || !r[1] && !r[2] && !r[3] && !r[4] || r[4] && n.match(this.rules.other.unicodeAlphaNumeric)) && (!(r[1] || r[3]) || !n || this.rules.inline.punctuation.exec(n))) {
			let i = [...r[0]].length - 1, a, o, s = i, c = 0, l = r[0][0], u = n === l, d = l === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
			for (d.lastIndex = 0, t = t.slice(-1 * e.length + i); (r = d.exec(t)) !== null;) {
				if (a = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !a) continue;
				if (o = [...a].length, r[3] || r[4]) {
					s += o;
					continue;
				} else if (r[5] || r[6]) {
					if (i % 3 && !((i + o) % 3)) {
						c += o;
						continue;
					}
					if (u) break;
				}
				if (s -= o, s > 0) continue;
				o = Math.min(o, o + s + c);
				let t = [...r[0]][0].length, n = e.slice(0, i + r.index + t + o);
				if (Math.min(i, o) % 2) {
					let e = n.slice(1, -1);
					return {
						type: "em",
						raw: n,
						text: e,
						tokens: this.lexer.inlineTokens(e)
					};
				}
				let l = n.slice(2, -2);
				return {
					type: "strong",
					raw: n,
					text: l,
					tokens: this.lexer.inlineTokens(l)
				};
			}
		}
	}
	codespan(e) {
		let t = this.rules.inline.code.exec(e);
		if (t) {
			let e = t[2].replace(this.rules.other.newLineCharGlobal, " "), n = this.rules.other.nonSpaceChar.test(e), r = this.rules.other.startingSpaceChar.test(e) && this.rules.other.endingSpaceChar.test(e);
			return n && r && (e = e.substring(1, e.length - 1)), {
				type: "codespan",
				raw: t[0],
				text: e
			};
		}
	}
	br(e) {
		let t = this.rules.inline.br.exec(e);
		if (t) return {
			type: "br",
			raw: t[0]
		};
	}
	del(e, t, n = "") {
		let r = this.rules.inline.delLDelim.exec(e);
		if (r && (!r[1] || !n || this.rules.inline.punctuation.exec(n))) {
			let n = [...r[0]].length - 1, i, a, o = n, s = this.rules.inline.delRDelim;
			for (s.lastIndex = 0, t = t.slice(-1 * e.length + n); (r = s.exec(t)) !== null;) {
				if (i = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !i || (a = [...i].length, a !== n)) continue;
				if (r[3] || r[4]) {
					o += a;
					continue;
				}
				if (o -= a, o > 0) continue;
				a = Math.min(a, a + o);
				let t = [...r[0]][0].length, s = e.slice(0, n + r.index + t + a), c = s.slice(n, -n);
				return {
					type: "del",
					raw: s,
					text: c,
					tokens: this.lexer.inlineTokens(c)
				};
			}
		}
	}
	autolink(e) {
		let t = this.rules.inline.autolink.exec(e);
		if (t) {
			let e, n;
			return t[2] === "@" ? (e = t[1], n = "mailto:" + e) : (e = t[1], n = e), {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				autolink: !0,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	url(e) {
		let t;
		if (t = this.rules.inline.url.exec(e)) {
			let e, n;
			if (t[2] === "@") e = t[0], n = "mailto:" + e;
			else {
				let r;
				do
					r = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
				while (r !== t[0]);
				e = t[0], n = t[1] === "www." ? "http://" + t[0] : t[0];
			}
			return {
				type: "link",
				raw: t[0],
				text: e,
				href: n,
				autolink: !0,
				tokens: [{
					type: "text",
					raw: e,
					text: e
				}]
			};
		}
	}
	inlineText(e) {
		let t = this.rules.inline.text.exec(e);
		if (t) {
			let e = this.lexer.state.inRawBlock;
			return {
				type: "text",
				raw: t[0],
				text: t[0],
				escaped: e
			};
		}
	}
}, Z = class e {
	tokens;
	options;
	state;
	inlineQueue;
	tokenizer;
	constructor(e) {
		this.tokens = [], this.tokens.links = Object.create(null), this.options = e || K, this.options.tokenizer = this.options.tokenizer || new kr(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
			inLink: !1,
			inRawBlock: !1,
			linkEmitted: !1,
			top: !0
		};
		let t = {
			other: J,
			block: hr.normal,
			inline: gr.normal
		};
		this.options.pedantic ? (t.block = hr.pedantic, t.inline = gr.pedantic) : this.options.gfm && (t.block = hr.gfm, this.options.breaks ? t.inline = gr.breaks : t.inline = gr.gfm), this.tokenizer.rules = t;
	}
	static get rules() {
		return {
			block: hr,
			inline: gr
		};
	}
	static lex(t, n) {
		return new e(n).lex(t);
	}
	static lexInline(t, n) {
		return new e(n).inlineTokens(t);
	}
	lex(e) {
		e = e.replace(J.carriageReturn, "\n"), this.blockTokens(e, this.tokens);
		for (let e = 0; e < this.inlineQueue.length; e++) {
			let t = this.inlineQueue[e];
			this.inlineTokens(t.src, t.tokens);
		}
		return this.inlineQueue = [], this.tokens;
	}
	blockTokens(e, t = [], n = !1) {
		this.tokenizer.lexer = this, this.options.pedantic && (e = e.replace(J.tabCharGlobal, "    ").replace(J.spaceLine, ""));
		let r = Infinity;
		for (; e;) {
			if (e.length < r) r = e.length;
			else {
				this.infiniteLoopError(e.charCodeAt(0));
				break;
			}
			let i;
			if (this.options.extensions?.block?.some((n) => (i = n.call({ lexer: this }, e, t)) ? (e = e.substring(i.raw.length), t.push(i), !0) : !1)) continue;
			if (i = this.tokenizer.space(e)) {
				e = e.substring(i.raw.length);
				let n = t.at(-1);
				i.raw.length === 1 && n !== void 0 ? n.raw += "\n" : t.push(i);
				continue;
			}
			if (i = this.tokenizer.code(e)) {
				e = e.substring(i.raw.length);
				let n = t.at(-1);
				n?.type === "paragraph" || n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + i.raw, n.text += "\n" + i.text, this.inlineQueue.at(-1).src = n.text) : t.push(i);
				continue;
			}
			if (i = this.tokenizer.fences(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.heading(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.hr(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.blockquote(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.list(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.html(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.def(e)) {
				e = e.substring(i.raw.length);
				let n = t.at(-1);
				n?.type === "paragraph" || n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + i.raw, n.text += "\n" + i.raw, this.inlineQueue.at(-1).src = n.text) : this.tokens.links[i.tag] || (this.tokens.links[i.tag] = {
					href: i.href,
					title: i.title
				}, t.push(i));
				continue;
			}
			if (i = this.tokenizer.table(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			if (i = this.tokenizer.lheading(e)) {
				e = e.substring(i.raw.length), t.push(i);
				continue;
			}
			let a = e;
			if (this.options.extensions?.startBlock) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startBlock.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (a = e.substring(0, t + 1));
			}
			if (this.state.top && (i = this.tokenizer.paragraph(a))) {
				let r = t.at(-1);
				n && r?.type === "paragraph" ? (r.raw += (r.raw.endsWith("\n") ? "" : "\n") + i.raw, r.text += "\n" + i.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = r.text) : t.push(i), n = a.length !== e.length, e = e.substring(i.raw.length);
				continue;
			}
			if (i = this.tokenizer.text(e)) {
				e = e.substring(i.raw.length);
				let n = t.at(-1);
				n?.type === "text" ? (n.raw += (n.raw.endsWith("\n") ? "" : "\n") + i.raw, n.text += "\n" + i.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = n.text) : t.push(i);
				continue;
			}
			if (e) {
				this.infiniteLoopError(e.charCodeAt(0));
				break;
			}
		}
		return this.state.top = !0, t;
	}
	inline(e, t = []) {
		return this.inlineQueue.push({
			src: e,
			tokens: t
		}), t;
	}
	linkInText(e) {
		if (!e.includes("[")) return !1;
		let t = this.tokenizer.rules.inline.link;
		for (let n of e.matchAll(this.tokenizer.rules.inline.blockSkip)) if (t.test(n[0]) && e.charAt(n.index - 1) !== "!") return !0;
		for (let t of e.matchAll(this.tokenizer.rules.inline.reflinkSearch)) {
			let e = t[0], n = e.lastIndexOf("[");
			if (!(e.charAt(0) === "!" || !Object.hasOwn(this.tokens.links, Cr(e.slice(n + 1, -1)))) && !(n > 1 && this.linkInText(e.slice(1, n - 1)))) return !0;
		}
		return !1;
	}
	inlineTokens(e, t = []) {
		this.tokenizer.lexer = this;
		let n = e;
		if (this.tokens.links && e.includes("[")) {
			let e = this.tokenizer.rules.inline.reflinkSearch, t = (n) => {
				let r = n.lastIndexOf("[");
				if (!Object.hasOwn(this.tokens.links, Cr(n.slice(r + 1, -1)))) return n;
				if (r > 1 && n.charAt(0) !== "!") {
					let i = n.slice(1, r - 1);
					if (this.linkInText(i)) return "[" + i.replace(e, t) + "][" + "a".repeat(n.length - r - 2) + "]";
				}
				return "[" + "a".repeat(n.length - 2) + "]";
			};
			n = n.replace(e, t);
		}
		n = n.replace(this.tokenizer.rules.inline.anyPunctuation, (e) => "+".repeat(e.length)), n = n.replace(this.tokenizer.rules.inline.blockSkip, (e, t, n) => {
			let r = n ? n.length : 0;
			return e.slice(0, r) + "[" + "a".repeat(e.length - r - 2) + "]";
		}), n = this.options.hooks?.emStrongMask?.call({ lexer: this }, n) ?? n;
		let r = !1, i = "", a = Infinity;
		for (; e;) {
			if (e.length < a) a = e.length;
			else {
				this.infiniteLoopError(e.charCodeAt(0));
				break;
			}
			r || (i = ""), r = !1;
			let o;
			if (this.options.extensions?.inline?.some((n) => (o = n.call({ lexer: this }, e, t)) ? (e = e.substring(o.raw.length), t.push(o), !0) : !1)) continue;
			if (o = this.tokenizer.escape(e)) {
				e = e.substring(o.raw.length), t.push(o);
				continue;
			}
			if (o = this.tokenizer.tag(e)) {
				e = e.substring(o.raw.length), t.push(o);
				continue;
			}
			if (o = this.tokenizer.link(e)) {
				e = e.substring(o.raw.length), t.push(o);
				continue;
			}
			if (o = this.tokenizer.reflink(e, this.tokens.links)) {
				e = e.substring(o.raw.length);
				let n = t.at(-1);
				o.type === "text" && n?.type === "text" ? (n.raw += o.raw, n.text += o.text) : t.push(o);
				continue;
			}
			if (o = this.tokenizer.emStrong(e, n, i)) {
				e = e.substring(o.raw.length), t.push(o);
				continue;
			}
			if (o = this.tokenizer.codespan(e)) {
				e = e.substring(o.raw.length), t.push(o);
				continue;
			}
			if (o = this.tokenizer.br(e)) {
				e = e.substring(o.raw.length), t.push(o);
				continue;
			}
			if (o = this.tokenizer.del(e, n, i)) {
				e = e.substring(o.raw.length), t.push(o);
				continue;
			}
			if (o = this.tokenizer.autolink(e)) {
				e = e.substring(o.raw.length), t.push(o);
				continue;
			}
			if (!this.state.inLink && (o = this.tokenizer.url(e))) {
				e = e.substring(o.raw.length), t.push(o);
				continue;
			}
			let s = e;
			if (this.options.extensions?.startInline) {
				let t = Infinity, n = e.slice(1), r;
				this.options.extensions.startInline.forEach((e) => {
					r = e.call({ lexer: this }, n), typeof r == "number" && r >= 0 && (t = Math.min(t, r));
				}), t < Infinity && t >= 0 && (s = e.substring(0, t + 1));
			}
			if (o = this.tokenizer.inlineText(s)) {
				e = e.substring(o.raw.length), o.raw.slice(-1) !== "_" && (i = o.raw.slice(-1)), r = !0;
				let n = t.at(-1);
				n?.type === "text" ? (n.raw += o.raw, n.text += o.text) : t.push(o);
				continue;
			}
			if (e) {
				this.infiniteLoopError(e.charCodeAt(0));
				break;
			}
		}
		return t;
	}
	infiniteLoopError(e) {
		let t = "Infinite loop on byte: " + e;
		if (this.options.silent) console.error(t);
		else throw Error(t);
	}
}, Ar = class {
	options;
	parser;
	constructor(e) {
		this.options = e || K;
	}
	space(e) {
		return "";
	}
	code({ text: e, lang: t, escaped: n }) {
		let r = (t || "").match(J.notSpaceStart)?.[0], i = e ? e.replace(J.endingNewline, "") + "\n" : "";
		return r ? "<pre><code class=\"language-" + X(r) + "\">" + (n ? i : X(i, !0)) + "</code></pre>\n" : "<pre><code>" + (n ? i : X(i, !0)) + "</code></pre>\n";
	}
	blockquote({ tokens: e }) {
		return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
	}
	html({ text: e }) {
		return e;
	}
	def(e) {
		return "";
	}
	heading({ tokens: e, depth: t }) {
		return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
	}
	hr(e) {
		return "<hr>\n";
	}
	list(e) {
		let t = e.ordered, n = e.start, r = "";
		for (let t = 0; t < e.items.length; t++) {
			let n = e.items[t];
			r += this.listitem(n);
		}
		let i = t ? "ol" : "ul", a = t && n !== 1 ? " start=\"" + n + "\"" : "";
		return "<" + i + a + ">\n" + r + "</" + i + ">\n";
	}
	listitem(e) {
		return `<li>${this.parser.parse(e.tokens)}</li>
`;
	}
	checkbox({ checked: e }) {
		return "<input " + (e ? "checked=\"\" " : "") + "disabled=\"\" type=\"checkbox\"> ";
	}
	paragraph({ tokens: e }) {
		return `<p>${this.parser.parseInline(e)}</p>
`;
	}
	table(e) {
		let t = "", n = "";
		for (let t = 0; t < e.header.length; t++) n += this.tablecell(e.header[t]);
		t += this.tablerow({ text: n });
		let r = "";
		for (let t = 0; t < e.rows.length; t++) {
			let i = e.rows[t];
			n = "";
			for (let e = 0; e < i.length; e++) n += this.tablecell(i[e]);
			r += this.tablerow({ text: n });
		}
		return r &&= `<tbody>${r}</tbody>`, "<table>\n<thead>\n" + t + "</thead>\n" + r + "</table>\n";
	}
	tablerow({ text: e }) {
		return `<tr>
${e}</tr>
`;
	}
	tablecell(e) {
		let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
		return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
	}
	strong({ tokens: e }) {
		return `<strong>${this.parser.parseInline(e)}</strong>`;
	}
	em({ tokens: e }) {
		return `<em>${this.parser.parseInline(e)}</em>`;
	}
	codespan({ text: e }) {
		return `<code>${X(e, !0)}</code>`;
	}
	br(e) {
		return "<br>";
	}
	del({ tokens: e }) {
		return `<del>${this.parser.parseInline(e)}</del>`;
	}
	link({ href: e, title: t, text: n, tokens: r, autolink: i }) {
		let a = i ? X(n, !0) : this.parser.parseInline(r), o = yr(e);
		if (o === null) return a;
		e = X(o, i);
		let s = "<a href=\"" + e + "\"";
		return t && (s += " title=\"" + X(t) + "\""), s += ">" + a + "</a>", s;
	}
	image({ href: e, title: t, text: n, tokens: r }) {
		r && (n = this.parser.parseInline(r, this.parser.textRenderer));
		let i = yr(e);
		if (i === null) return X(n);
		e = i;
		let a = `<img src="${X(e)}" alt="${X(n)}"`;
		return t && (a += ` title="${X(t)}"`), a += ">", a;
	}
	text(e) {
		return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : X(e.text);
	}
}, jr = class {
	strong({ text: e }) {
		return e;
	}
	em({ text: e }) {
		return e;
	}
	codespan({ text: e }) {
		return e;
	}
	del({ text: e }) {
		return e;
	}
	html({ text: e }) {
		return e;
	}
	text({ text: e }) {
		return e;
	}
	link({ text: e }) {
		return "" + e;
	}
	image({ text: e }) {
		return "" + e;
	}
	br() {
		return "";
	}
	checkbox({ raw: e }) {
		return e;
	}
}, Q = class e {
	options;
	renderer;
	textRenderer;
	constructor(e) {
		this.options = e || K, this.options.renderer = this.options.renderer || new Ar(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new jr();
	}
	static parse(t, n) {
		return new e(n).parse(t);
	}
	static parseInline(t, n) {
		return new e(n).parseInline(t);
	}
	parse(e) {
		this.renderer.parser = this;
		let t = "";
		for (let n = 0; n < e.length; n++) {
			let r = e[n];
			if (this.options.extensions?.renderers?.[r.type]) {
				let e = r, n = this.options.extensions.renderers[e.type].call({ parser: this }, e);
				if (n !== !1 || ![
					"space",
					"hr",
					"heading",
					"code",
					"table",
					"blockquote",
					"list",
					"checkbox",
					"html",
					"def",
					"paragraph",
					"text"
				].includes(e.type)) {
					t += n || "";
					continue;
				}
			}
			let i = r;
			switch (i.type) {
				case "space":
					t += this.renderer.space(i);
					break;
				case "hr":
					t += this.renderer.hr(i);
					break;
				case "heading":
					t += this.renderer.heading(i);
					break;
				case "code":
					t += this.renderer.code(i);
					break;
				case "table":
					t += this.renderer.table(i);
					break;
				case "blockquote":
					t += this.renderer.blockquote(i);
					break;
				case "list":
					t += this.renderer.list(i);
					break;
				case "checkbox":
					t += this.renderer.checkbox(i);
					break;
				case "html":
					t += this.renderer.html(i);
					break;
				case "def":
					t += this.renderer.def(i);
					break;
				case "paragraph":
					t += this.renderer.paragraph(i);
					break;
				case "text":
					t += this.renderer.text(i);
					break;
				default: {
					let e = "Token with \"" + i.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return t;
	}
	parseInline(e, t = this.renderer) {
		this.renderer.parser = this;
		let n = "";
		for (let r = 0; r < e.length; r++) {
			let i = e[r];
			if (this.options.extensions?.renderers?.[i.type]) {
				let e = this.options.extensions.renderers[i.type].call({ parser: this }, i);
				if (e !== !1 || ![
					"escape",
					"html",
					"link",
					"image",
					"checkbox",
					"strong",
					"em",
					"codespan",
					"br",
					"del",
					"text"
				].includes(i.type)) {
					n += e || "";
					continue;
				}
			}
			let a = i;
			switch (a.type) {
				case "escape":
					n += t.text(a);
					break;
				case "html":
					n += t.html(a);
					break;
				case "link":
					n += t.link(a);
					break;
				case "image":
					n += t.image(a);
					break;
				case "checkbox":
					n += t.checkbox(a);
					break;
				case "strong":
					n += t.strong(a);
					break;
				case "em":
					n += t.em(a);
					break;
				case "codespan":
					n += t.codespan(a);
					break;
				case "br":
					n += t.br(a);
					break;
				case "del":
					n += t.del(a);
					break;
				case "text":
					n += t.text(a);
					break;
				default: {
					let e = "Token with \"" + a.type + "\" type was not found.";
					if (this.options.silent) return console.error(e), "";
					throw Error(e);
				}
			}
		}
		return n;
	}
}, Mr = class {
	options;
	block;
	constructor(e) {
		this.options = e || K;
	}
	static passThroughHooks = /* @__PURE__ */ new Set([
		"preprocess",
		"postprocess",
		"processAllTokens",
		"emStrongMask"
	]);
	static passThroughHooksRespectAsync = /* @__PURE__ */ new Set([
		"preprocess",
		"postprocess",
		"processAllTokens"
	]);
	preprocess(e) {
		return e;
	}
	postprocess(e) {
		return e;
	}
	processAllTokens(e) {
		return e;
	}
	emStrongMask(e) {
		return e;
	}
	provideLexer(e = this.block) {
		return e ? Z.lex : Z.lexInline;
	}
	provideParser(e = this.block) {
		return e ? Q.parse : Q.parseInline;
	}
}, Nr = new class {
	defaults = Qt();
	options = this.setOptions;
	parse = this.parseMarkdown(!0);
	parseInline = this.parseMarkdown(!1);
	Parser = Q;
	Renderer = Ar;
	TextRenderer = jr;
	Lexer = Z;
	Tokenizer = kr;
	Hooks = Mr;
	constructor(...e) {
		this.use(...e);
	}
	walkTokens(e, t) {
		let n = [];
		for (let r of e) switch (n = n.concat(t.call(this, r)), r.type) {
			case "table": {
				let e = r;
				for (let r of e.header) n = n.concat(this.walkTokens(r.tokens, t));
				for (let r of e.rows) for (let e of r) n = n.concat(this.walkTokens(e.tokens, t));
				break;
			}
			case "list": {
				let e = r;
				n = n.concat(this.walkTokens(e.items, t));
				break;
			}
			default: {
				let e = r;
				this.defaults.extensions?.childTokens?.[e.type] ? this.defaults.extensions.childTokens[e.type].forEach((r) => {
					let i = e[r].flat(Infinity);
					n = n.concat(this.walkTokens(i, t));
				}) : e.tokens && (n = n.concat(this.walkTokens(e.tokens, t)));
			}
		}
		return n;
	}
	use(...e) {
		let t = this.defaults.extensions || {
			renderers: {},
			childTokens: {}
		};
		return e.forEach((e) => {
			let n = { ...e };
			if (n.async = this.defaults.async || n.async || !1, e.extensions && (e.extensions.forEach((e) => {
				if (!e.name) throw Error("extension name required");
				if ("renderer" in e) {
					let n = t.renderers[e.name];
					n ? t.renderers[e.name] = function(...t) {
						let r = e.renderer.apply(this, t);
						return r === !1 && (r = n.apply(this, t)), r;
					} : t.renderers[e.name] = e.renderer;
				}
				if ("tokenizer" in e) {
					if (!e.level || e.level !== "block" && e.level !== "inline") throw Error("extension level must be 'block' or 'inline'");
					let n = t[e.level];
					n ? n.unshift(e.tokenizer) : t[e.level] = [e.tokenizer], e.start && (e.level === "block" ? t.startBlock ? t.startBlock.push(e.start) : t.startBlock = [e.start] : e.level === "inline" && (t.startInline ? t.startInline.push(e.start) : t.startInline = [e.start]));
				}
				"childTokens" in e && e.childTokens && (t.childTokens[e.name] = e.childTokens);
			}), n.extensions = t), e.renderer) {
				let t = this.defaults.renderer || new Ar(this.defaults);
				for (let n in e.renderer) {
					if (!(n in t)) throw Error(`renderer '${n}' does not exist`);
					if (["options", "parser"].includes(n)) continue;
					let r = n, i = e.renderer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n || "";
					};
				}
				n.renderer = t;
			}
			if (e.tokenizer) {
				let t = this.defaults.tokenizer || new kr(this.defaults);
				for (let n in e.tokenizer) {
					if (!(n in t)) throw Error(`tokenizer '${n}' does not exist`);
					if ([
						"options",
						"rules",
						"lexer"
					].includes(n)) continue;
					let r = n, i = e.tokenizer[r], a = t[r];
					t[r] = (...e) => {
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.tokenizer = t;
			}
			if (e.hooks) {
				let t = this.defaults.hooks || new Mr();
				for (let n in e.hooks) {
					if (!(n in t)) throw Error(`hook '${n}' does not exist`);
					if (["options", "block"].includes(n)) continue;
					let r = n, i = e.hooks[r], a = t[r];
					Mr.passThroughHooks.has(n) ? t[r] = (e) => {
						if (this.defaults.async && Mr.passThroughHooksRespectAsync.has(n)) return (async () => {
							let n = await i.call(t, e);
							return a.call(t, n);
						})();
						let r = i.call(t, e);
						return a.call(t, r);
					} : t[r] = (...e) => {
						if (this.defaults.async) return (async () => {
							let n = await i.apply(t, e);
							return n === !1 && (n = await a.apply(t, e)), n;
						})();
						let n = i.apply(t, e);
						return n === !1 && (n = a.apply(t, e)), n;
					};
				}
				n.hooks = t;
			}
			if (e.walkTokens) {
				let t = this.defaults.walkTokens, r = e.walkTokens;
				n.walkTokens = function(e) {
					let n = [];
					return n.push(r.call(this, e)), t && (n = n.concat(t.call(this, e))), n;
				};
			}
			this.defaults = {
				...this.defaults,
				...n
			};
		}), this;
	}
	setOptions(e) {
		return this.defaults = {
			...this.defaults,
			...e
		}, this;
	}
	lexer(e, t) {
		return Z.lex(e, t ?? this.defaults);
	}
	parser(e, t) {
		return Q.parse(e, t ?? this.defaults);
	}
	parseMarkdown(e) {
		return (t, n) => {
			let r = { ...n }, i = {
				...this.defaults,
				...r
			}, a = this.onError(!!i.silent, !!i.async);
			if (this.defaults.async === !0 && r.async === !1) return a(/* @__PURE__ */ Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
			if (typeof t > "u" || t === null) return a(/* @__PURE__ */ Error("marked(): input parameter is undefined or null"));
			if (typeof t != "string") return a(/* @__PURE__ */ Error("marked(): input parameter is of type " + Object.prototype.toString.call(t) + ", string expected"));
			if (i.hooks && (i.hooks.options = i, i.hooks.block = e), i.async) return (async () => {
				let n = i.hooks ? await i.hooks.preprocess(t) : t, r = await (i.hooks ? await i.hooks.provideLexer(e) : e ? Z.lex : Z.lexInline)(n, i), a = i.hooks ? await i.hooks.processAllTokens(r) : r;
				i.walkTokens && await Promise.all(this.walkTokens(a, i.walkTokens));
				let o = await (i.hooks ? await i.hooks.provideParser(e) : e ? Q.parse : Q.parseInline)(a, i);
				return i.hooks ? await i.hooks.postprocess(o) : o;
			})().catch(a);
			try {
				i.hooks && (t = i.hooks.preprocess(t));
				let n = (i.hooks ? i.hooks.provideLexer(e) : e ? Z.lex : Z.lexInline)(t, i);
				i.hooks && (n = i.hooks.processAllTokens(n)), i.walkTokens && this.walkTokens(n, i.walkTokens);
				let r = (i.hooks ? i.hooks.provideParser(e) : e ? Q.parse : Q.parseInline)(n, i);
				return i.hooks && (r = i.hooks.postprocess(r)), r;
			} catch (e) {
				return a(e);
			}
		};
	}
	onError(e, t) {
		return (n) => {
			if (n.message += "\nPlease report this to https://github.com/markedjs/marked.", e) {
				let e = "<p>An error occurred:</p><pre>" + X(n.message + "", !0) + "</pre>";
				return t ? Promise.resolve(e) : e;
			}
			if (t) return Promise.reject(n);
			throw n;
		};
	}
}();
function $(e, t) {
	return Nr.parse(e, t);
}
$.options = $.setOptions = function(e) {
	return Nr.setOptions(e), $.defaults = Nr.defaults, $t($.defaults), $;
}, $.getDefaults = Qt, $.defaults = K;
function Pr(...e) {
	return Nr.use(...e), $.defaults = Nr.defaults, $t($.defaults), $;
}
$.use = Pr, $.walkTokens = function(e, t) {
	return Nr.walkTokens(e, t);
}, $.parseInline = Nr.parseInline, $.Parser = Q, $.parser = Q.parse, $.Renderer = Ar, $.TextRenderer = jr, $.Lexer = Z, $.lexer = Z.lex, $.Tokenizer = kr, $.Hooks = Mr, $.parse = $, $.options, $.setOptions, $.walkTokens, $.parseInline, Q.parse, Z.lex;
//#endregion
//#region src/components/data/rich-text/MarkdownRenderer/MarkdownRenderer.tsx
function Fr({ content: e, className: n }) {
	let r = oe(() => Zt.sanitize($(e, { async: !1 })), [e]);
	return /* @__PURE__ */ C("div", {
		className: t("[&_h1]:mt-6 [&_h1]:mb-3 [&_h1]:text-xl [&_h1]:font-semibold [&_h1:first-child]:mt-0", "[&_h2]:mt-5 [&_h2]:mb-2.5 [&_h2]:text-lg [&_h2]:font-semibold [&_h2:first-child]:mt-0", "[&_h3]:mt-4 [&_h3]:mb-2 [&_h3]:text-base [&_h3]:font-semibold [&_h3:first-child]:mt-0", "[&_p]:mb-3 [&_p:last-child]:mb-0", "[&_strong]:font-semibold [&_em]:italic", "[&_a]:text-primary [&_a]:underline [&_a]:underline-offset-2", "[&_ul]:mb-3 [&_ul]:ml-4 [&_ul]:list-disc [&_ol]:mb-3 [&_ol]:ml-4 [&_ol]:list-decimal", "[&_li]:mb-0.5", n),
		dangerouslySetInnerHTML: { __html: r }
	});
}
//#endregion
//#region src/components/data/rich-text/RichTextEditor/RichTextEditor.tsx
var Ir = [
	{
		name: "bold",
		icon: be,
		label: "Bold",
		toggle: (e) => e.chain().focus().toggleBold().run()
	},
	{
		name: "italic",
		icon: Se,
		label: "Italic",
		toggle: (e) => e.chain().focus().toggleItalic().run()
	},
	{
		name: "bulletList",
		icon: k,
		label: "Bullet list",
		toggle: (e) => e.chain().focus().toggleBulletList().run()
	},
	{
		name: "orderedList",
		icon: Ce,
		label: "Ordered list",
		toggle: (e) => e.chain().focus().toggleOrderedList().run()
	}
];
function Lr({ id: e, ariaLabel: r, value: i, onChange: a, placeholder: o, className: s }) {
	let c = se(i ?? ""), l = me({
		extensions: [he.configure({
			heading: !1,
			codeBlock: !1,
			blockquote: !1,
			horizontalRule: !1,
			strike: !1,
			code: !1,
			trailingNode: !1
		})],
		shouldRerenderOnTransaction: !0,
		content: i ?? "",
		onUpdate: ({ editor: e }) => {
			let t = e.getHTML();
			c.current = t, a(t);
		},
		editorProps: { attributes: {
			...e ? { id: e } : {},
			...r ? { "aria-label": r } : {},
			role: "textbox",
			"aria-multiline": "true",
			class: "min-h-[80px] outline-none py-2 text-base md:text-sm [&_ul]:ml-4 [&_ul]:list-disc [&_ol]:ml-4 [&_ol]:list-decimal [&_li]:mb-0.5"
		} }
	});
	return ae(() => {
		l && i !== c.current && (l.commands.setContent(i ?? "", { emitUpdate: !1 }), c.current = i ?? "");
	}, [l, i]), /* @__PURE__ */ w("div", {
		className: t("rounded-md border border-input bg-background ring-offset-background", "focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2", s),
		children: [l && /* @__PURE__ */ C("div", {
			className: "border-input flex gap-1 border-b p-1",
			children: Ir.map(({ name: e, icon: r, label: i, toggle: a }) => /* @__PURE__ */ C(n, {
				type: "button",
				variant: "ghost",
				size: "sm",
				className: t("h-7 w-7 p-0", l.isActive(e) && "bg-muted"),
				onClick: () => a(l),
				"aria-label": i,
				children: /* @__PURE__ */ C(r, { className: "h-3.5 w-3.5" })
			}, e))
		}), /* @__PURE__ */ w("div", {
			className: "relative px-3",
			children: [l?.getHTML() === "<p></p>" && o && /* @__PURE__ */ C("p", {
				className: "text-muted-foreground pointer-events-none absolute py-2 text-base md:text-sm",
				"aria-hidden": !0,
				children: o
			}), /* @__PURE__ */ C(pe, { editor: l })]
		})]
	});
}
//#endregion
//#region src/components/data/rich-text/RichTextPreview/RichTextPreview.tsx
function Rr({ content: e, lines: n = 2, className: r }) {
	let i = oe(() => e && !ne(e) ? Zt.sanitize(e) : null, [e]);
	return i ? /* @__PURE__ */ C("div", {
		style: { WebkitLineClamp: n },
		className: t("overflow-hidden [display:-webkit-box] [-webkit-box-orient:vertical]", "[&_p]:inline [&_p]:after:content-[\"_\"]", "[&_li]:inline [&_li]:before:content-[\"·_\"]", "[&_ul]:inline [&_ul]:p-0 [&_ul]:m-0", "[&_ol]:inline [&_ol]:p-0 [&_ol]:m-0", "[&_strong]:font-semibold [&_em]:italic", r),
		dangerouslySetInnerHTML: { __html: i }
	}) : null;
}
//#endregion
//#region src/components/data/rich-text/RichTextRenderer/RichTextRenderer.tsx
function zr({ content: e, className: n }) {
	let r = oe(() => e && !ne(e) ? Zt.sanitize(e) : null, [e]);
	return r ? /* @__PURE__ */ C("div", {
		className: t("[&_p]:mb-2 [&_p:last-child]:mb-0", "[&_strong]:font-semibold [&_em]:italic", "[&_ul]:ml-4 [&_ul]:list-disc [&_ol]:ml-4 [&_ol]:list-decimal", "[&_li]:mb-0.5", n),
		dangerouslySetInnerHTML: { __html: r }
	}) : null;
}
//#endregion
//#region src/components/data/stats/ReportCard/ReportCard.tsx
function Br({ label: e, sub: t, value: n, tone: r = "neutral", isLoading: i = !1 }) {
	return /* @__PURE__ */ w("div", {
		className: "bg-card rounded-xl border p-5",
		children: [
			/* @__PURE__ */ C(v, {
				variant: "overline",
				color: "muted",
				children: e
			}),
			i ? /* @__PURE__ */ C(f, {
				variant: "text",
				className: "mt-0.5 h-4 w-28"
			}) : /* @__PURE__ */ C(v, {
				variant: "body-sm",
				color: "muted",
				className: "mt-0.5",
				children: t
			}),
			i ? /* @__PURE__ */ C(f, {
				variant: "text",
				className: "mt-4 h-8 w-24"
			}) : /* @__PURE__ */ C(v, {
				variant: "display",
				color: r === "danger" ? "destructive" : "default",
				className: "mt-4 tabular-nums",
				children: n
			})
		]
	});
}
//#endregion
//#region src/components/data/stats/ReportSection/ReportSection.tsx
function Vr({ title: e, subtitle: n, action: r, className: i, children: a }) {
	return /* @__PURE__ */ w("div", {
		className: t("bg-card rounded-xl border p-5", i),
		children: [/* @__PURE__ */ w("div", {
			className: "flex items-start justify-between",
			children: [/* @__PURE__ */ w("div", { children: [/* @__PURE__ */ C(v, {
				variant: "overline",
				color: "muted",
				children: e
			}), /* @__PURE__ */ C(v, {
				variant: "body-sm",
				color: "muted",
				className: "mt-0.5",
				children: n
			})] }), r]
		}), a]
	});
}
//#endregion
//#region src/components/data/stats/SummaryStat/SummaryStat.tsx
function Hr({ label: e, value: n, sub: r, tone: i = "neutral", icon: a, isLoading: o = !1, valueClassName: s }) {
	return /* @__PURE__ */ w("div", {
		className: "bg-card rounded-xl border p-[18px]",
		children: [
			/* @__PURE__ */ w("div", {
				className: "flex items-center justify-between",
				children: [/* @__PURE__ */ C(v, {
					variant: "overline",
					color: "muted",
					children: e
				}), /* @__PURE__ */ C(a, { className: t("size-4", i === "danger" ? "text-destructive-text/50" : "text-muted-foreground/40") })]
			}),
			o ? /* @__PURE__ */ C(f, {
				variant: "text",
				className: t("mt-2.5 h-7 w-20", s)
			}) : /* @__PURE__ */ C(v, {
				variant: "display",
				as: "div",
				color: i === "danger" ? "destructive" : "default",
				className: t("mt-2.5 tabular-nums", s),
				children: n
			}),
			o ? /* @__PURE__ */ C(f, {
				variant: "text",
				className: "mt-1.5 h-3.5 w-28"
			}) : /* @__PURE__ */ C(v, {
				variant: "caption",
				color: "muted",
				className: "mt-1.5",
				children: r
			})
		]
	});
}
//#endregion
//#region src/components/data/stats/SummaryStatGroup/SummaryStatGroup.tsx
function Ur({ children: e, className: n }) {
	return /* @__PURE__ */ C("div", {
		className: t("flex snap-x snap-mandatory gap-3 overflow-x-auto", "-mx-8 scroll-px-8 px-8 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden", "[&>*]:w-64 [&>*]:shrink-0 [&>*]:snap-start", "sm:mx-0 sm:grid sm:snap-none sm:overflow-visible sm:px-0 sm:[&>*]:w-auto", n),
		children: e
	});
}
//#endregion
//#region src/components/data/DetailCard/DetailCard.tsx
function Wr({ title: e, description: n, icon: r, headerAction: i, footer: a, footerAlign: o = "start", className: s, contentClassName: c, children: l }) {
	return /* @__PURE__ */ w("div", {
		className: t("bg-card overflow-hidden rounded-xl border shadow-sm", s),
		children: [
			/* @__PURE__ */ w("div", {
				className: "flex flex-wrap items-start justify-between gap-x-3 gap-y-2 border-b p-4",
				children: [/* @__PURE__ */ w("div", {
					className: "flex min-w-0 items-start gap-2.5",
					children: [r && /* @__PURE__ */ C(r, { className: "text-muted-foreground mt-0.5 size-4 shrink-0" }), /* @__PURE__ */ w("div", { children: [/* @__PURE__ */ C(v, {
						variant: "h6",
						children: e
					}), n && /* @__PURE__ */ C(v, {
						variant: "body-sm",
						color: "muted",
						children: n
					})] })]
				}), i]
			}),
			l != null && l !== !1 && /* @__PURE__ */ C("div", {
				className: c ?? "p-4",
				children: l
			}),
			a && /* @__PURE__ */ C("div", {
				className: t("border-t p-4", o === "end" && "flex flex-wrap items-center justify-end gap-2"),
				children: a
			})
		]
	});
}
//#endregion
//#region src/components/data/UpcomingReminders/UpcomingReminders.tsx
var Gr = 864e5, Kr = "9:00 am";
function qr(e) {
	return e.slice(0, 10);
}
function Jr(e, t) {
	return Math.round((Date.parse(`${qr(e)}T00:00:00Z`) - Date.parse(`${t}T00:00:00Z`)) / Gr);
}
function Yr(e) {
	return (/* @__PURE__ */ new Date(`${qr(e)}T00:00:00Z`)).toLocaleDateString("en-AU", {
		weekday: "short",
		day: "numeric",
		month: "short",
		timeZone: "UTC"
	});
}
function Xr(e, t) {
	let n = Jr(e, t);
	return n === 0 ? "Today" : n === 1 ? "Tomorrow" : Yr(e);
}
function Zr(e) {
	return e === 1 ? "1 day" : `${e} days`;
}
function Qr(e) {
	return e === 0 ? "On the due date" : e < 0 ? `${Zr(-e)} before due` : `${Zr(e)} after due`;
}
function $r({ label: e, children: t }) {
	return /* @__PURE__ */ w(x, { children: [/* @__PURE__ */ C(y, {
		asChild: !0,
		children: /* @__PURE__ */ C("span", {
			role: "img",
			"aria-label": e,
			tabIndex: 0,
			className: "focus-visible:ring-ring inline-flex rounded-sm focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none",
			children: t
		})
	}), /* @__PURE__ */ C(b, { children: e })] });
}
function ei(e, t) {
	return new Intl.NumberFormat("en-AU", {
		style: "currency",
		currency: t
	}).format(e);
}
function ti({ label: e, disabledReason: r, onClick: i, isDestructive: a = !1, children: o }) {
	let s = !!r;
	return /* @__PURE__ */ w(x, { children: [/* @__PURE__ */ C(y, {
		asChild: !0,
		children: /* @__PURE__ */ C("span", {
			className: "inline-flex",
			tabIndex: s ? 0 : void 0,
			children: /* @__PURE__ */ C(n, {
				type: "button",
				variant: "ghost",
				size: "icon",
				className: t("text-muted-foreground size-9 rounded-full sm:size-8", a && "hover:text-destructive-text"),
				"aria-label": s ? `${e} (${r})` : e,
				disabled: s,
				onClick: i,
				children: o
			})
		})
	}), /* @__PURE__ */ C(b, { children: r ?? e })] });
}
function ni({ reminder: t, getInvoiceHref: n, LinkComponent: r }) {
	return n ? /* @__PURE__ */ C(r, {
		...e(r, n(t.invoiceId)),
		className: "hover:text-foreground font-medium underline-offset-2 hover:underline",
		children: t.invoiceNumber
	}) : /* @__PURE__ */ C(le, { children: t.invoiceNumber });
}
function ri({ reminder: e }) {
	return /* @__PURE__ */ w("span", {
		className: "text-muted-foreground inline-flex gap-1",
		children: [e.emailClient && /* @__PURE__ */ C($r, {
			label: "Emails the client",
			children: /* @__PURE__ */ C(we, {
				className: "size-3.5",
				"aria-hidden": "true"
			})
		}), e.alertStaff && /* @__PURE__ */ C($r, {
			label: e.emailClient ? "Alerts you" : "Alerts you only — no client email",
			children: /* @__PURE__ */ C(E, {
				className: "size-3.5",
				"aria-hidden": "true"
			})
		})]
	});
}
function ii({ reminder: n, today: r, showInvoice: i, showDay: a, isCompact: o, getSendNowBlockedReason: s, getInvoiceHref: c, getClientHref: l, renderChannelBadge: u, onSendNow: d, onDismiss: ee, onRestore: f, LinkComponent: p }) {
	let m = n.status === "DISMISSED", h = Jr(n.scheduledDate, r), te = Xr(n.scheduledDate, r);
	return /* @__PURE__ */ w("li", {
		className: "grid grid-cols-[minmax(0,1fr)_auto] items-center gap-2 border-t py-3 first:border-t-0 first:pt-0 sm:py-2.5",
		children: [o ? /* @__PURE__ */ w("div", {
			className: t("flex min-w-0 flex-wrap items-center gap-x-1.5 text-sm", m && "text-muted-foreground line-through"),
			children: [
				u ? u(n) : /* @__PURE__ */ C(ri, { reminder: n }),
				/* @__PURE__ */ C(re, {
					name: n.clientName,
					size: "xs"
				}),
				l && n.clientId ? /* @__PURE__ */ C(p, {
					...e(p, l(n.clientId)),
					className: "font-semibold underline-offset-2 hover:underline",
					children: n.clientName
				}) : /* @__PURE__ */ C("span", {
					className: "font-semibold",
					children: n.clientName
				}),
				/* @__PURE__ */ C("span", {
					className: "text-muted-foreground",
					children: "·"
				}),
				/* @__PURE__ */ C(ni, {
					reminder: n,
					getInvoiceHref: c,
					LinkComponent: p
				}),
				m && /* @__PURE__ */ C("span", {
					className: "text-muted-foreground rounded-full border px-2 text-xs font-medium no-underline",
					children: "Dismissed"
				})
			]
		}) : /* @__PURE__ */ w("div", {
			className: "min-w-0",
			children: [
				/* @__PURE__ */ C("p", {
					className: t("text-[13px] font-semibold", m && "text-muted-foreground line-through"),
					children: a ? /* @__PURE__ */ w(le, { children: [
						te,
						" ",
						/* @__PURE__ */ w("span", {
							className: "text-muted-foreground text-xs font-normal tabular-nums",
							children: [
								"· ",
								h <= 1 ? `${Yr(n.scheduledDate)}, ` : "",
								Kr
							]
						})
					] }) : /* @__PURE__ */ C("span", {
						className: "text-muted-foreground text-xs font-normal tabular-nums",
						children: Kr
					})
				}),
				/* @__PURE__ */ w("div", {
					className: "flex flex-wrap items-center gap-1.5 text-[13px]",
					children: [/* @__PURE__ */ w("span", {
						className: t("inline-flex items-center gap-1", m && "text-muted-foreground line-through"),
						children: [u ? u(n) : /* @__PURE__ */ C(ri, { reminder: n }), /* @__PURE__ */ w("span", { children: ["· ", Qr(n.daysRelativeToDue)] })]
					}), m && /* @__PURE__ */ C("span", {
						className: "text-muted-foreground rounded-full border px-2 text-xs font-medium",
						children: "Dismissed"
					})]
				}),
				i && /* @__PURE__ */ w("p", {
					className: "text-muted-foreground text-xs",
					children: [
						n.clientName,
						" ·",
						" ",
						/* @__PURE__ */ C(ni, {
							reminder: n,
							getInvoiceHref: c,
							LinkComponent: p
						})
					]
				})
			]
		}), /* @__PURE__ */ C("div", {
			className: "flex flex-wrap justify-end gap-0.5",
			children: m ? f && /* @__PURE__ */ C(ti, {
				label: "Restore reminder",
				disabledReason: h <= 0 ? "Too late to restore this reminder" : null,
				onClick: () => f(n),
				children: /* @__PURE__ */ C(j, { className: "size-4" })
			}) : [n.emailClient && d && /* @__PURE__ */ C(ti, {
				label: "Send reminder now",
				disabledReason: s?.(n),
				onClick: () => d(n),
				children: /* @__PURE__ */ C(De, { className: "size-4" })
			}, "send"), ee && /* @__PURE__ */ C(ti, {
				label: "Dismiss reminder",
				onClick: () => ee(n),
				isDestructive: !0,
				children: /* @__PURE__ */ C(ye, { className: "size-4" })
			}, "dismiss")]
		})]
	});
}
function ai(e, t) {
	let n = /* @__PURE__ */ new Map();
	for (let r of e) {
		let e = t(r);
		n.set(e, [...n.get(e) ?? [], r]);
	}
	return [...n.entries()];
}
function oi({ reminders: e, today: r, groupBy: i = "none", invoiceLayout: a = "sections", showInvoice: o = i === "day", showDay: s = i !== "day", getSendNowBlockedReason: c, getInvoiceHref: l, getClientHref: u, renderChannelBadge: d, onSendNow: ee, onDismiss: f, onRestore: p, onStopAll: m, emptyMessage: h = "Nothing scheduled.", linkComponent: te = "a", pageSize: g, className: _ }) {
	let [v, y] = ce(1);
	if (e.length === 0) return /* @__PURE__ */ C("p", {
		className: t("text-muted-foreground text-sm", _),
		children: h
	});
	let b = [...e].sort((e, t) => e.scheduledDate.localeCompare(t.scheduledDate)), x = i === "invoice" ? ai(b, (e) => e.invoiceId) : [], ne = i === "invoice" ? x.length : b.length, re = g ? Math.ceil(ne / g) : 1, S = Math.min(v, re), ae = g ? (S - 1) * g : 0, oe = g ? ae + g : ne, se = i === "invoice" ? b : b.slice(ae, oe), le = x.slice(ae, oe), ue = /* @__PURE__ */ C(ie, {
		page: S,
		pageCount: re,
		onPageChange: y,
		summary: `${ae + 1}–${Math.min(oe, ne)} of ${ne} ${i === "invoice" ? "invoices" : "reminders"}`
	}), T = (e, t) => /* @__PURE__ */ C("ul", { children: e.map((e) => /* @__PURE__ */ C(ii, {
		reminder: e,
		today: r,
		showInvoice: o,
		showDay: t,
		isCompact: i === "day",
		getSendNowBlockedReason: c,
		getInvoiceHref: l,
		getClientHref: u,
		renderChannelBadge: d,
		onSendNow: ee,
		onDismiss: f,
		onRestore: p,
		LinkComponent: te
	}, e.id)) });
	if (i === "none") return /* @__PURE__ */ w("div", {
		className: _,
		children: [T(se, s), ue]
	});
	if (i === "day") return /* @__PURE__ */ w("div", {
		className: _,
		children: [ai(se, (e) => qr(e.scheduledDate)).map(([e, t]) => /* @__PURE__ */ w("section", {
			"aria-label": Xr(e, r),
			className: "border-t pt-3 first:border-t-0 first:pt-0",
			children: [/* @__PURE__ */ w("h4", {
				className: "text-foreground pb-1 text-xs font-semibold",
				children: [
					Xr(e, r),
					" ",
					/* @__PURE__ */ w("span", {
						className: "text-muted-foreground font-normal tabular-nums",
						children: ["· ", Kr]
					})
				]
			}), T(t, s)]
		}, e)), ue]
	});
	let de = (e) => /* @__PURE__ */ w(n, {
		type: "button",
		variant: "ghost",
		size: "sm",
		className: "text-destructive-text h-7 rounded-full px-2.5 text-xs",
		onClick: () => m?.(e),
		children: [/* @__PURE__ */ C(A, {
			className: "size-3 fill-current",
			"aria-hidden": "true"
		}), "Stop reminders"]
	});
	return a === "cards" ? /* @__PURE__ */ w("div", {
		className: _,
		children: [/* @__PURE__ */ C("div", {
			className: "grid gap-4 md:grid-cols-2 xl:grid-cols-3",
			children: le.map(([e, t]) => {
				let [n] = t, r = t.some((e) => e.status === "SCHEDULED");
				return /* @__PURE__ */ C("section", {
					"aria-label": n.invoiceNumber,
					children: /* @__PURE__ */ C(Wr, {
						className: "h-full",
						title: /* @__PURE__ */ C(ni, {
							reminder: n,
							getInvoiceHref: l,
							LinkComponent: te
						}),
						description: `${n.dueAt ? `Due ${Yr(n.dueAt)} · ` : ""}${ei(n.invoiceTotal, n.currency)}`,
						headerAction: m && r ? de(e) : null,
						children: T(t, s)
					})
				}, e);
			})
		}), ue]
	}) : /* @__PURE__ */ w("div", {
		className: _,
		children: [le.map(([e, t]) => {
			let [n] = t, r = t.some((e) => e.status === "SCHEDULED");
			return /* @__PURE__ */ w("section", {
				"aria-label": n.invoiceNumber,
				className: "border-t pt-3 first:border-t-0 first:pt-0",
				children: [/* @__PURE__ */ w("h4", {
					className: "text-muted-foreground flex flex-wrap items-center justify-between gap-2 pb-1 text-xs font-semibold",
					children: [/* @__PURE__ */ w("span", { children: [
						/* @__PURE__ */ C("span", {
							className: "text-foreground",
							children: /* @__PURE__ */ C(ni, {
								reminder: n,
								getInvoiceHref: l,
								LinkComponent: te
							})
						}),
						n.dueAt && ` · due ${Yr(n.dueAt)}`,
						" ·",
						" ",
						ei(n.invoiceTotal, n.currency)
					] }), m && r && de(e)]
				}), T(t, s)]
			}, e);
		}), ue]
	});
}
//#endregion
export { Oe as BulkActionBar, ke as ColumnVisibilityMenu, Be as DataTable, Wr as DetailCard, Fr as MarkdownRenderer, Br as ReportCard, Vr as ReportSection, Lr as RichTextEditor, Rr as RichTextPreview, zr as RichTextRenderer, N as RowActions, M as RowActionsMenu, Hr as SummaryStat, Ur as SummaryStatGroup, oi as UpcomingReminders, Qr as describeReminderOffset };

//# sourceMappingURL=index.js.map